var items = {
  "block.minecraft.acacia_button": "Сәрүәр төймәһе",
  "block.minecraft.acacia_door": "Сәрүәр ишеге",
  "block.minecraft.acacia_fence": "Сәрүәр ҡоймаһы",
  "block.minecraft.acacia_fence_gate": "Сәрүәр ҡапҡаһы",
  "block.minecraft.acacia_hanging_sign": "Сәрүәр алтаҡта",
  "block.minecraft.acacia_leaves": "Сәрүәр япраҡтары",
  "block.minecraft.acacia_log": "Сәрүәр бүрәнәһе",
  "block.minecraft.acacia_planks": "Сәрүәр таҡталары",
  "block.minecraft.acacia_pressure_plate": "Сәрүәр ҡыҫым плитаһы",
  "block.minecraft.acacia_sapling": "Сәрүәр үҫентеһе",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Сәрүәр яҙмаҡсалығы",
  "block.minecraft.acacia_slab": "Сәрүәр плитаһы",
  "block.minecraft.acacia_stairs": "Сәрүәр баҫҡыстары",
  "block.minecraft.acacia_trapdoor": "Сәрүәр люгы",
  "block.minecraft.acacia_wall_hanging_sign": "Сәрүәр диуар алтаҡтаһы",
  "block.minecraft.acacia_wall_sign": "Сәрүәр диуар билдәһе",
  "block.minecraft.acacia_wood": "Сәрүәр",
  "block.minecraft.activator_rail": "Әүҙемләткес тимер юл",
  "block.minecraft.air": "Һауа",
  "block.minecraft.allium": "Йыллау һуған",
  "block.minecraft.amethyst_block": "Аметист блогы",
  "block.minecraft.amethyst_cluster": "Аметист бәйләме",
  "block.minecraft.ancient_debris": "Боронғо вайранлыҡтар",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Андезит плитаһы",
  "block.minecraft.andesite_stairs": "Андезит баҫҡыстары",
  "block.minecraft.andesite_wall": "Андезит ҡоймаһы",
  "block.minecraft.anvil": "Һандал",
  "block.minecraft.attached_melon_stem": "Беркетелгән ҡарбуз һабағы",
  "block.minecraft.attached_pumpkin_stem": "Беркетелгән ҡабаҡ һабағы",
  "block.minecraft.azalea": "Азалия",
  "block.minecraft.azalea_leaves": "Азалия япраҡтары",
  "block.minecraft.azure_bluet": "Зәңгәр күк сәскә",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Бамбук блоғы",
  "block.minecraft.bamboo_button": "Бамбук төймәһе",
  "block.minecraft.bamboo_door": "Бамбук ишеге",
  "block.minecraft.bamboo_fence": "Бамбук ҡоймаһы",
  "block.minecraft.bamboo_fence_gate": "Бамбук ҡапҡаһы",
  "block.minecraft.bamboo_hanging_sign": "Бамбук алтаҡта",
  "block.minecraft.bamboo_mosaic": "Бамбук мозаика",
  "block.minecraft.bamboo_mosaic_slab": "Бамбук мозаика плитаһы",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбук мозаика баҫҡыстары",
  "block.minecraft.bamboo_planks": "Бамбук таҡталары",
  "block.minecraft.bamboo_pressure_plate": "Бамбук ҡыҫым плитаһы",
  "block.minecraft.bamboo_sapling": "Бамбук үҫентеһе",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Бамбук яҙмаҡсалығы",
  "block.minecraft.bamboo_slab": "Бамбук плитаһы",
  "block.minecraft.bamboo_stairs": "Бамбук баҫҡыстары",
  "block.minecraft.bamboo_trapdoor": "Бамбук люк",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбук диуар алтаҡтаһы",
  "block.minecraft.bamboo_wall_sign": "Бамбук диуар билдәһе",
  "block.minecraft.banner.base.black": "Тулыһынса ҡара",
  "block.minecraft.banner.base.blue": "Тулыһынса күк",
  "block.minecraft.banner.base.brown": "Тулыһынса көрән",
  "block.minecraft.banner.base.cyan": "Тулыһынса фирүзә",
  "block.minecraft.banner.base.gray": "Тулыһынса һоро",
  "block.minecraft.banner.base.green": "Тулыһынса йәшел",
  "block.minecraft.banner.base.light_blue": "Тулыһынса зәңгәр",
  "block.minecraft.banner.base.light_gray": "Тулыһынса аҡһыл һоро",
  "block.minecraft.banner.base.lime": "Тулыһынса йәшкелт",
  "block.minecraft.banner.base.magenta": "Тулыһынса ҡуйы ҡыҙыл",
  "block.minecraft.banner.base.orange": "Тулыһынса ҡыҙғылт һары",
  "block.minecraft.banner.base.pink": "Тулыһынса алһыу",
  "block.minecraft.banner.base.purple": "Тулыһынса шәмәхә",
  "block.minecraft.banner.base.red": "Тулыһынса ҡыҙыл",
  "block.minecraft.banner.base.white": "Тулыһынса аҡ",
  "block.minecraft.banner.base.yellow": "Тулыһынса һары",
  "block.minecraft.banner.border.black": "Ҡара ҡайма",
  "block.minecraft.banner.border.blue": "Күк ҡайма",
  "block.minecraft.banner.border.brown": "Кәрән ҡайма",
  "block.minecraft.banner.border.cyan": "Фирүзә ҡайма",
  "block.minecraft.banner.border.gray": "Һоро ҡайма",
  "block.minecraft.banner.border.green": "Йәшел ҡайма",
  "block.minecraft.banner.border.light_blue": "Зәңгәр ҡайма",
  "block.minecraft.banner.border.light_gray": "Аҡһыл һоро ҡайма",
  "block.minecraft.banner.border.lime": "Йәшкелт ҡайма",
  "block.minecraft.banner.border.magenta": "Ҡуйы ҡыҙыл ҡайма",
  "block.minecraft.banner.border.orange": "Хәнәүәт ҡайма",
  "block.minecraft.banner.border.pink": "Алһыу ҡайма",
  "block.minecraft.banner.border.purple": "Шәмәхә ҡайма",
  "block.minecraft.banner.border.red": "Ҡыҙыл ҡайма",
  "block.minecraft.banner.border.white": "Аҡ ҡайма",
  "block.minecraft.banner.border.yellow": "Һары ҡайма",
  "block.minecraft.banner.bricks.black": "Ҡара кирбес",
  "block.minecraft.banner.bricks.blue": "Күк кирбес",
  "block.minecraft.banner.bricks.brown": "Көрән кирбес",
  "block.minecraft.banner.bricks.cyan": "Фирүзә кирбес",
  "block.minecraft.banner.bricks.gray": "Һоро кирбес",
  "block.minecraft.banner.bricks.green": "Йәшел кирбес",
  "block.minecraft.banner.bricks.light_blue": "Зәңгәр кирбес",
  "block.minecraft.banner.bricks.light_gray": "Аҡһыл һоро кирбес",
  "block.minecraft.banner.bricks.lime": "Йәшкелт кирбес",
  "block.minecraft.banner.bricks.magenta": "Ҡуйы ҡыҙыл кирбес",
  "block.minecraft.banner.bricks.orange": "Хәнәүәт кирбес",
  "block.minecraft.banner.bricks.pink": "Алһыу кирбес",
  "block.minecraft.banner.bricks.purple": "Шәмәхә кирбес",
  "block.minecraft.banner.bricks.red": "Ҡыҙыл кирбес",
  "block.minecraft.banner.bricks.white": "Аҡ кирбес",
  "block.minecraft.banner.bricks.yellow": "Һары кирбес",
  "block.minecraft.banner.circle.black": "Ҡара даирә",
  "block.minecraft.banner.circle.blue": "Күк даирә",
  "block.minecraft.banner.circle.brown": "Көрән даирә",
  "block.minecraft.banner.circle.cyan": "Фирүзә даирә",
  "block.minecraft.banner.circle.gray": "Һоро даирә",
  "block.minecraft.banner.circle.green": "Йәшел даирә",
  "block.minecraft.banner.circle.light_blue": "Зәңгәр даирә",
  "block.minecraft.banner.circle.light_gray": "Аҡһыл һоро даирә",
  "block.minecraft.banner.circle.lime": "Йәшкелт даирә",
  "block.minecraft.banner.circle.magenta": "Ҡуйы ҡыҙыл даирә",
  "block.minecraft.banner.circle.orange": "Хәнәүәт даирә",
  "block.minecraft.banner.circle.pink": "Алһыу даирә",
  "block.minecraft.banner.circle.purple": "Шәмәхә даирә",
  "block.minecraft.banner.circle.red": "Ҡыҙыл даирә",
  "block.minecraft.banner.circle.white": "Аҡ даирә",
  "block.minecraft.banner.circle.yellow": "Һары даирә",
  "block.minecraft.banner.creeper.black": "Ҡара крипер",
  "block.minecraft.banner.creeper.blue": "Күк крипер",
  "block.minecraft.banner.creeper.brown": "Көрән крипер",
  "block.minecraft.banner.creeper.cyan": "Фирүзә крипер",
  "block.minecraft.banner.creeper.gray": "Һоро крипер",
  "block.minecraft.banner.creeper.green": "Йәшел крипер",
  "block.minecraft.banner.creeper.light_blue": "Зәңгәр крипер",
  "block.minecraft.banner.creeper.light_gray": "Аҡһыл һоро крипер",
  "block.minecraft.banner.creeper.lime": "Йәшкелт крипер",
  "block.minecraft.banner.creeper.magenta": "Ҡуйы ҡыҙыл крипер",
  "block.minecraft.banner.creeper.orange": "Хәнәүәт крипер",
  "block.minecraft.banner.creeper.pink": "Алһыу крипер",
  "block.minecraft.banner.creeper.purple": "Шәмәхә крипер",
  "block.minecraft.banner.creeper.red": "Ҡыҙыл крипер",
  "block.minecraft.banner.creeper.white": "Аҡ крипер",
  "block.minecraft.banner.creeper.yellow": "Һары крипер",
  "block.minecraft.banner.cross.black": "Ҡара ҡыйыш тәре",
  "block.minecraft.banner.cross.blue": "Күк ҡыйыш тәре",
  "block.minecraft.banner.cross.brown": "Көрән ҡыйыш тәре",
  "block.minecraft.banner.cross.cyan": "Фирүзә ҡыйыш тәре",
  "block.minecraft.banner.cross.gray": "Һоро ҡыйыш тәре",
  "block.minecraft.banner.cross.green": "Йәшел ҡыйыш тәре",
  "block.minecraft.banner.cross.light_blue": "Зәңгәр ҡыйыш тәре",
  "block.minecraft.banner.cross.light_gray": "Аҡһыл һоро ҡыйыш тәре",
  "block.minecraft.banner.cross.lime": "Йәшкелт ҡыйыш тәре",
  "block.minecraft.banner.cross.magenta": "Ҡуйы ҡыҙыл ҡыйыш тәре",
  "block.minecraft.banner.cross.orange": "Хәнәүәт ҡыйыш тәре",
  "block.minecraft.banner.cross.pink": "Алһыу ҡыйыш тәре",
  "block.minecraft.banner.cross.purple": "Шәмәхә ҡыйыш тәре",
  "block.minecraft.banner.cross.red": "Ҡыҙыл ҡыйыш тәре",
  "block.minecraft.banner.cross.white": "Аҡ ҡыйыш тәре",
  "block.minecraft.banner.cross.yellow": "Һары ҡыйыш тәре",
  "block.minecraft.banner.curly_border.black": "Ҡара тешле ҡайма",
  "block.minecraft.banner.curly_border.blue": "Күк тешле ҡайма",
  "block.minecraft.banner.curly_border.brown": "Көрән тешле ҡайма",
  "block.minecraft.banner.curly_border.cyan": "Фирүзә тешле ҡайма",
  "block.minecraft.banner.curly_border.gray": "Һоро тешле ҡайма",
  "block.minecraft.banner.curly_border.green": "Йәшел тешле ҡайма",
  "block.minecraft.banner.curly_border.light_blue": "Зәңгәр тешле ҡайма",
  "block.minecraft.banner.curly_border.light_gray": "Аҡһыл һоро тешле ҡайма",
  "block.minecraft.banner.curly_border.lime": "Йәшкелт тешле ҡайма",
  "block.minecraft.banner.curly_border.magenta": "Ҡуйы ҡыҙыл тешле ҡайма",
  "block.minecraft.banner.curly_border.orange": "Хәнәүәт тешле ҡайма",
  "block.minecraft.banner.curly_border.pink": "Алһыу тешле ҡайма",
  "block.minecraft.banner.curly_border.purple": "Шәмәхә тешле ҡайма",
  "block.minecraft.banner.curly_border.red": "Ҡыҙыл тешле ҡайма",
  "block.minecraft.banner.curly_border.white": "Аҡ тешле ҡайма",
  "block.minecraft.banner.curly_border.yellow": "Һары тешле ҡайма",
  "block.minecraft.banner.diagonal_left.black": "Ҡара өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.blue": "Күк өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.brown": "Көрән өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.cyan": "Фирүзә өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.gray": "Һоро өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.green": "Йәшел өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.light_blue": "Зәңгәр өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.light_gray": "Аҡһыл һоро өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.lime": "Йәшкелт өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.magenta": "Ҡуйы ҡыҙыл өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.orange": "Хәнәүәт өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.pink": "Алһыу өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.purple": "Шәмәхә өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.red": "Ҡыҙыл өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.white": "Аҡ өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_left.yellow": "Һары өҫкө һул бөгөл",
  "block.minecraft.banner.diagonal_right.black": "Ҡара ҡайыш",
  "block.minecraft.banner.diagonal_right.blue": "Күк ҡайыш",
  "block.minecraft.banner.diagonal_right.brown": "Көрән ҡайыш",
  "block.minecraft.banner.diagonal_right.cyan": "Фирүзә ҡайыш",
  "block.minecraft.banner.diagonal_right.gray": "Һоро ҡайыш",
  "block.minecraft.banner.diagonal_right.green": "Йәшел ҡайыш",
  "block.minecraft.banner.diagonal_right.light_blue": "Зәңгәр ҡайыш",
  "block.minecraft.banner.diagonal_right.light_gray": "Аҡһыл һоро ҡайыш",
  "block.minecraft.banner.diagonal_right.lime": "Йәшкелт ҡайыш",
  "block.minecraft.banner.diagonal_right.magenta": "Ҡуйы ҡыҙыл ҡайыш",
  "block.minecraft.banner.diagonal_right.orange": "Хәнәүәт ҡайыш",
  "block.minecraft.banner.diagonal_right.pink": "Алһыу ҡайыш",
  "block.minecraft.banner.diagonal_right.purple": "Шәмәхә ҡайыш",
  "block.minecraft.banner.diagonal_right.red": "Ҡыҙыл ҡайыш",
  "block.minecraft.banner.diagonal_right.white": "Аҡ ҡайыш",
  "block.minecraft.banner.diagonal_right.yellow": "Һары ҡайыш",
  "block.minecraft.banner.diagonal_up_left.black": "Ҡара аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.blue": "Күк аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.brown": "Көрән аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.cyan": "Фирүзә аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.gray": "Һоро аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.green": "Йәшел аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Зәңгәр аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Аҡһыл һоро аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.lime": "Йәшкелт аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.magenta": "Ҡуйы ҡыҙыл аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.orange": "Хәнәүәт аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.pink": "Алһыу аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.purple": "Шәмәхә аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.red": "Ҡыҙыл аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.white": "Аҡ аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_left.yellow": "Һары аҫҡы һул бөгөл",
  "block.minecraft.banner.diagonal_up_right.black": "Ҡара аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.blue": "Күк аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.brown": "Көрән аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.cyan": "Фирүзә аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.gray": "Һоро аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.green": "Йәшел аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Зәңгәр аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Аҡһыл һоро аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.lime": "Йәшкелт аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.magenta": "Ҡуйы ҡыҙыл аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.orange": "Хәнәүәт аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.pink": "Алһыу аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.purple": "Шәмәхә аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.red": "Ҡыҙыл аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.white": "Аҡ аҫҡы уң бөгөл",
  "block.minecraft.banner.diagonal_up_right.yellow": "Һары аҫҡы уң бөгөл",
  "block.minecraft.banner.flow.black": "Ҡара ағым",
  "block.minecraft.banner.flow.blue": "Күк ағым",
  "block.minecraft.banner.flow.brown": "Көрән ағым",
  "block.minecraft.banner.flow.cyan": "Фирүзә ағым",
  "block.minecraft.banner.flow.gray": "Һоро ағым",
  "block.minecraft.banner.flow.green": "Йәшел ағым",
  "block.minecraft.banner.flow.light_blue": "Зәңгәр ағым",
  "block.minecraft.banner.flow.light_gray": "Аҡһыл һоро ағым",
  "block.minecraft.banner.flow.lime": "Йәшкелт ағым",
  "block.minecraft.banner.flow.magenta": "Ҡуйы ҡыҙыл ағым",
  "block.minecraft.banner.flow.orange": "Хәнәүәт ағым",
  "block.minecraft.banner.flow.pink": "Алһыу ағым",
  "block.minecraft.banner.flow.purple": "Шәмәхә ағым",
  "block.minecraft.banner.flow.red": "Ҡыҙыл ағым",
  "block.minecraft.banner.flow.white": "Аҡ ағым",
  "block.minecraft.banner.flow.yellow": "Һары ағым",
  "block.minecraft.banner.flower.black": "Ҡара сәскә",
  "block.minecraft.banner.flower.blue": "Күк сәскә",
  "block.minecraft.banner.flower.brown": "Көрән сәскә",
  "block.minecraft.banner.flower.cyan": "Фирүзә сәскә",
  "block.minecraft.banner.flower.gray": "Һоро сәскә",
  "block.minecraft.banner.flower.green": "Йәшел сәскә",
  "block.minecraft.banner.flower.light_blue": "Зәңгәр сәскә",
  "block.minecraft.banner.flower.light_gray": "Аҡ һоро сәскә",
  "block.minecraft.banner.flower.lime": "Йәшкелт сәскә",
  "block.minecraft.banner.flower.magenta": "Ҡуйы ҡыҙыл сәскә",
  "block.minecraft.banner.flower.orange": "Хәнәүәт сәскә",
  "block.minecraft.banner.flower.pink": "Алһыу сәскә",
  "block.minecraft.banner.flower.purple": "Шәмәхә сәскә",
  "block.minecraft.banner.flower.red": "Ҡыҙыл сәскә",
  "block.minecraft.banner.flower.white": "Аҡ сәскә",
  "block.minecraft.banner.flower.yellow": "Һары сәскә",
  "block.minecraft.banner.globe.black": "Ҡара глобус",
  "block.minecraft.banner.globe.blue": "Күк глобус",
  "block.minecraft.banner.globe.brown": "Көрән глобус",
  "block.minecraft.banner.globe.cyan": "Фирүзә глобус",
  "block.minecraft.banner.globe.gray": "Һоро глобус",
  "block.minecraft.banner.globe.green": "Йәшел глобус",
  "block.minecraft.banner.globe.light_blue": "Зәңгәр глобус",
  "block.minecraft.banner.globe.light_gray": "Аҡһыл һоро глобус",
  "block.minecraft.banner.globe.lime": "Йәшкелт глобус",
  "block.minecraft.banner.globe.magenta": "Ҡуйы ҡыҙыл глобус",
  "block.minecraft.banner.globe.orange": "Хәнәүәт глобус",
  "block.minecraft.banner.globe.pink": "Алһыу глобус",
  "block.minecraft.banner.globe.purple": "Шәмәхә глобус",
  "block.minecraft.banner.globe.red": "Ҡыҙыл глобус",
  "block.minecraft.banner.globe.white": "Аҡ глобус",
  "block.minecraft.banner.globe.yellow": "Һары глобус",
  "block.minecraft.banner.gradient.black": "Ҡара градиент",
  "block.minecraft.banner.gradient.blue": "Күк градиент",
  "block.minecraft.banner.gradient.brown": "Көрән градиент",
  "block.minecraft.banner.gradient.cyan": "Фирүзә градиент",
  "block.minecraft.banner.gradient.gray": "Һоро градиент",
  "block.minecraft.banner.gradient.green": "Йәшел градиент",
  "block.minecraft.banner.gradient.light_blue": "Зәңгәр градиент",
  "block.minecraft.banner.gradient.light_gray": "Аҡһыл һоро градиент",
  "block.minecraft.banner.gradient.lime": "Йәшкелт градиент",
  "block.minecraft.banner.gradient.magenta": "Ҡуйы ҡыҙыл градиент",
  "block.minecraft.banner.gradient.orange": "Хәнәүәт градиент",
  "block.minecraft.banner.gradient.pink": "Алһыу градиент",
  "block.minecraft.banner.gradient.purple": "Шәмәхә градиент",
  "block.minecraft.banner.gradient.red": "Ҡыҙыл градиент",
  "block.minecraft.banner.gradient.white": "Аҡ градиент",
  "block.minecraft.banner.gradient.yellow": "Һары градиент",
  "block.minecraft.banner.gradient_up.black": "Ҡара аҫҡы градиент",
  "block.minecraft.banner.gradient_up.blue": "Күк аҫҡы градиент",
  "block.minecraft.banner.gradient_up.brown": "Көрән аҫҡы градиент",
  "block.minecraft.banner.gradient_up.cyan": "Фирүзә аҫҡы градиент",
  "block.minecraft.banner.gradient_up.gray": "Һоро аҫҡы градиент",
  "block.minecraft.banner.gradient_up.green": "Йәшел аҫҡы градиент",
  "block.minecraft.banner.gradient_up.light_blue": "Зәңгәр аҫҡы градиент",
  "block.minecraft.banner.gradient_up.light_gray": "Аҡһыл һоро аҫҡы градиент",
  "block.minecraft.banner.gradient_up.lime": "Йәшкелт аҫҡы градиент",
  "block.minecraft.banner.gradient_up.magenta": "Ҡуйы ҡыҙыл аҫҡы градиент",
  "block.minecraft.banner.gradient_up.orange": "Хәнәүәт аҫҡы градиент",
  "block.minecraft.banner.gradient_up.pink": "Алһыу аҫҡы градиент",
  "block.minecraft.banner.gradient_up.purple": "Шәмәхә аҫҡы градиент",
  "block.minecraft.banner.gradient_up.red": "Ҡыҙыл аҫҡы градиент",
  "block.minecraft.banner.gradient_up.white": "Аҡ аҫҡы градиент",
  "block.minecraft.banner.gradient_up.yellow": "Һары аҫҡы градиент",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Ҡара өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.blue": "Күк өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.brown": "Көрән өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.cyan": "Фирүзә өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.gray": "Һоро өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.green": "Йәшел өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.light_blue": "Зәңгәр өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.light_gray": "Аҡһыл һоро өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.lime": "Йәшкелт өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.magenta": "Ҡуйы ҡыҙыл өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.orange": "Хәнәүәт өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.pink": "Алһыу өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.purple": "Шәмәхә өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.red": "Ҡыҙыл өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.white": "Аҡ өҫкө яҡ",
  "block.minecraft.banner.half_horizontal.yellow": "Һары өҫкө яҡ",
  "block.minecraft.banner.half_horizontal_bottom.black": "Ҡара аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Күк аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Көрән аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Фирүзә аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Һоро аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.green": "Йәшел аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Зәңгәр аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Аҡһыл һоро аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Йәшкелт аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Ҡуйы ҡыҙыл аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Хәнәүәт аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Алһыу аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Шәмәхә өҫкө яҡ",
  "block.minecraft.banner.half_horizontal_bottom.red": "Ҡыҙыл аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.white": "Аҡ аҫҡы яҡ",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Һары аҫҡы яҡ",
  "block.minecraft.banner.half_vertical.black": "Ҡара һул яҡ",
  "block.minecraft.banner.half_vertical.blue": "Күк һул яҡ",
  "block.minecraft.banner.half_vertical.brown": "Көрән һул яҡ",
  "block.minecraft.banner.half_vertical.cyan": "Фирүзә һул яҡ",
  "block.minecraft.banner.half_vertical.gray": "Һоро һул яҡ",
  "block.minecraft.banner.half_vertical.green": "Йәшел һул яҡ",
  "block.minecraft.banner.half_vertical.light_blue": "Зәңгәр һул яҡ",
  "block.minecraft.banner.half_vertical.light_gray": "Аҡ һоро һул яҡ",
  "block.minecraft.banner.half_vertical.lime": "Йәшкелт һул яҡ",
  "block.minecraft.banner.half_vertical.magenta": "Ҡуйы ҡыҙыл һул яҡ",
  "block.minecraft.banner.half_vertical.orange": "Хәнәүәт һул яҡ",
  "block.minecraft.banner.half_vertical.pink": "Алһыу һул яҡ",
  "block.minecraft.banner.half_vertical.purple": "Шәмәхә һул яҡ",
  "block.minecraft.banner.half_vertical.red": "Ҡыҙыл һул яҡ",
  "block.minecraft.banner.half_vertical.white": "Аҡ һул яҡ",
  "block.minecraft.banner.half_vertical.yellow": "Һары һул яҡ",
  "block.minecraft.banner.half_vertical_right.black": "Ҡара уң яҡ",
  "block.minecraft.banner.half_vertical_right.blue": "Күк уң яҡ",
  "block.minecraft.banner.half_vertical_right.brown": "Көрән уң яҡ",
  "block.minecraft.banner.half_vertical_right.cyan": "Фирүзә уң яҡ",
  "block.minecraft.banner.half_vertical_right.gray": "Һоро уң яҡ",
  "block.minecraft.banner.half_vertical_right.green": "Йәшел уң яҡ",
  "block.minecraft.banner.half_vertical_right.light_blue": "Зәңгәр уң яҡ",
  "block.minecraft.banner.half_vertical_right.light_gray": "Аҡһыл һоро уң яҡ",
  "block.minecraft.banner.half_vertical_right.lime": "Йәшкелт уң яҡ",
  "block.minecraft.banner.half_vertical_right.magenta": "Ҡуйы ҡыҙыл уң яҡ",
  "block.minecraft.banner.half_vertical_right.orange": "Хәнәүәт уң яҡ",
  "block.minecraft.banner.half_vertical_right.pink": "Алһыу уң яҡ",
  "block.minecraft.banner.half_vertical_right.purple": "Шәмәхә уң яҡ",
  "block.minecraft.banner.half_vertical_right.red": "Ҡыҙыл уң яҡ",
  "block.minecraft.banner.half_vertical_right.white": "Аҡ уң яҡ",
  "block.minecraft.banner.half_vertical_right.yellow": "Һары уң яҡ",
  "block.minecraft.banner.mojang.black": "Ҡара бер нәмә",
  "block.minecraft.banner.mojang.blue": "Күк бер нәмә",
  "block.minecraft.banner.mojang.brown": "Көрән бер нәмә",
  "block.minecraft.banner.mojang.cyan": "Фирүзә бер нәмә",
  "block.minecraft.banner.mojang.gray": "Һоро бер нәмә",
  "block.minecraft.banner.mojang.green": "Йәшел бер нәмә",
  "block.minecraft.banner.mojang.light_blue": "Зәңгәр бер нәмә",
  "block.minecraft.banner.mojang.light_gray": "Аҡһыл һоро бер нәмә",
  "block.minecraft.banner.mojang.lime": "Йәшкелт бер нәмә",
  "block.minecraft.banner.mojang.magenta": "Ҡуйы ҡыҙыл бер нәмә",
  "block.minecraft.banner.mojang.orange": "Хәнәүәт бер нәмә",
  "block.minecraft.banner.mojang.pink": "Алһыу бер нәмә",
  "block.minecraft.banner.mojang.purple": "Шәмәхә бер нәмә",
  "block.minecraft.banner.mojang.red": "Ҡыҙыл бер нәмә",
  "block.minecraft.banner.mojang.white": "Аҡ бер нәмә",
  "block.minecraft.banner.mojang.yellow": "Һары бер нәмә",
  "block.minecraft.banner.piglin.black": "Ҡара томшоҡ",
  "block.minecraft.banner.piglin.blue": "Күк томшоҡ",
  "block.minecraft.banner.piglin.brown": "Көрән томшоҡ",
  "block.minecraft.banner.piglin.cyan": "Фирүзә томшоҡ",
  "block.minecraft.banner.piglin.gray": "Һоро томшоҡ",
  "block.minecraft.banner.piglin.green": "Йәшел томшоҡ",
  "block.minecraft.banner.piglin.light_blue": "Зәңгәр томшоҡ",
  "block.minecraft.banner.piglin.light_gray": "Аҡһыл һоро томшоҡ",
  "block.minecraft.banner.piglin.lime": "Лайм төҫлө томшоҡ",
  "block.minecraft.banner.piglin.magenta": "Ҡуйы ҡыҙыл томшоҡ",
  "block.minecraft.banner.piglin.orange": "Хәнәүәт томшоҡ",
  "block.minecraft.banner.piglin.pink": "Ал томшоҡ",
  "block.minecraft.banner.piglin.purple": "Шәмәхә томшоҡ",
  "block.minecraft.banner.piglin.red": "Ҡыҙыл томшоҡ",
  "block.minecraft.banner.piglin.white": "Аҡ томшоҡ",
  "block.minecraft.banner.piglin.yellow": "Һары томшоҡ",
  "block.minecraft.banner.rhombus.black": "Ҡара ромб",
  "block.minecraft.banner.rhombus.blue": "Күк ромб",
  "block.minecraft.banner.rhombus.brown": "Көрән ромб",
  "block.minecraft.banner.rhombus.cyan": "Фирүзә ромб",
  "block.minecraft.banner.rhombus.gray": "Һоро ромб",
  "block.minecraft.banner.rhombus.green": "Йәшел ромб",
  "block.minecraft.banner.rhombus.light_blue": "Зәңгәр ромб",
  "block.minecraft.banner.rhombus.light_gray": "Аҡһыл һоро ромб",
  "block.minecraft.banner.rhombus.lime": "Йәшкелт ромб",
  "block.minecraft.banner.rhombus.magenta": "Ҡуйы ҡыҙыл ромб",
  "block.minecraft.banner.rhombus.orange": "Хәнәүәт ромб",
  "block.minecraft.banner.rhombus.pink": "Алһыу ромб",
  "block.minecraft.banner.rhombus.purple": "Шәмәхә ромб",
  "block.minecraft.banner.rhombus.red": "Ҡыҙыл ромб",
  "block.minecraft.banner.rhombus.white": "Аҡ ромб",
  "block.minecraft.banner.rhombus.yellow": "Һары ромб",
  "block.minecraft.banner.skull.black": "Ҡара баш һөйәге",
  "block.minecraft.banner.skull.blue": "Күк баш һөйәге",
  "block.minecraft.banner.skull.brown": "Көрән баш һөйәге",
  "block.minecraft.banner.skull.cyan": "Фирүзә баш һөйәге",
  "block.minecraft.banner.skull.gray": "Һоро баш һөйәге",
  "block.minecraft.banner.skull.green": "Йәшел баш һөйәге",
  "block.minecraft.banner.skull.light_blue": "Зәңгәр баш һөйәге",
  "block.minecraft.banner.skull.light_gray": "Аҡһыл һоро баш һөйәге",
  "block.minecraft.banner.skull.lime": "Йәшкелт баш һөйәге",
  "block.minecraft.banner.skull.magenta": "Ҡуйы ҡыҙыл баш һөйәге",
  "block.minecraft.banner.skull.orange": "Хәнәүәт баш һөйәге",
  "block.minecraft.banner.skull.pink": "Алһыу баш һөйәге",
  "block.minecraft.banner.skull.purple": "Шәмәхә баш һөйәге",
  "block.minecraft.banner.skull.red": "Ҡыҙыл баш һөйәге",
  "block.minecraft.banner.skull.white": "Аҡ баш һөйәге",
  "block.minecraft.banner.skull.yellow": "Һары баш һөйәге",
  "block.minecraft.banner.small_stripes.black": "Ҡара бағаналар",
  "block.minecraft.banner.small_stripes.blue": "Күк бағаналар",
  "block.minecraft.banner.small_stripes.brown": "Көрән бағаналар",
  "block.minecraft.banner.small_stripes.cyan": "Фирүзә бағаналар",
  "block.minecraft.banner.small_stripes.gray": "Һоро бағаналар",
  "block.minecraft.banner.small_stripes.green": "Йәшел бағаналар",
  "block.minecraft.banner.small_stripes.light_blue": "Зәңгәр бағаналар",
  "block.minecraft.banner.small_stripes.light_gray": "Аҡһыл һоро бағаналар",
  "block.minecraft.banner.small_stripes.lime": "Йәшкелт бағаналар",
  "block.minecraft.banner.small_stripes.magenta": "Ҡуйы ҡыҙыл бағаналар",
  "block.minecraft.banner.small_stripes.orange": "Хәнәүәт бағаналар",
  "block.minecraft.banner.small_stripes.pink": "Алһыу бағаналар",
  "block.minecraft.banner.small_stripes.purple": "Шәмәхә бағаналар",
  "block.minecraft.banner.small_stripes.red": "Ҡыҙыл бағаналар",
  "block.minecraft.banner.small_stripes.white": "Аҡ бағаналар",
  "block.minecraft.banner.small_stripes.yellow": "Һары бағаналар",
  "block.minecraft.banner.square_bottom_left.black": "Ҡара аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.blue": "Күк аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.brown": "Көрән аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.cyan": "Фирүзә аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.gray": "Һоро аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.green": "Йәшел аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.light_blue": "Зәңгәр аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.light_gray": "Аҡһыл һоро аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.lime": "Йәшкелт аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.magenta": "Ҡуйы ҡыҙыл аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.orange": "Хәнәүәт аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.pink": "Алһыу аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.purple": "Шәмәхә аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.red": "Ҡыҙыл аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.white": "Аҡ аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_left.yellow": "Һары аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_right.black": "Ҡара аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.blue": "Күк аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.brown": "Көрән аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.cyan": "Фирүзә аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.gray": "Һоро аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.green": "Йәшел аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.light_blue": "Зәңгәр аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.light_gray": "Аҡһыл һоро аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.lime": "Йәшкелт аҫҡы уң майҙан",
  "block.minecraft.banner.square_bottom_right.magenta": "Ҡуйы ҡыҙыл аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.orange": "Хәнәүәт аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.pink": "Алһыу аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.purple": "Шәмәхә аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.red": "Ҡыҙыл аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.white": "Аҡ аҫҡы һул майҙан",
  "block.minecraft.banner.square_bottom_right.yellow": "Һары аҫҡы һул майҙан",
  "block.minecraft.banner.square_top_left.black": "Ҡара өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.blue": "Күк өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.brown": "Көрән өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.cyan": "Фирүзә өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.gray": "Һоро өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.green": "Йәшел өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.light_blue": "Зәңгәр өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.light_gray": "Аҡһыл һоро өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.lime": "Йәшкелт өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.magenta": "Ҡуйы ҡыҙыл өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.orange": "Хәнәүәт өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.pink": "Алһыу өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.purple": "Шәмәхә өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.red": "Ҡыҙыл өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.white": "Аҡ өҫкө уң майҙан",
  "block.minecraft.banner.square_top_left.yellow": "Һары өҫкө уң майҙан",
  "block.minecraft.banner.square_top_right.black": "Ҡара өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.blue": "Күк өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.brown": "Көрән өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.cyan": "Фирүзә өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.gray": "Һоро өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.green": "Йәшел өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.light_blue": "Зәңгәр өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.light_gray": "Аҡһыл һоро өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.lime": "Йәшкелт өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.magenta": "Ҡуйы ҡыҙыл өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.orange": "Хәнәүәт өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.pink": "Алһыу өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.purple": "Шәмәхә өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.red": "Ҡыҙыл өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.white": "Аҡ өҫкө һул майҙан",
  "block.minecraft.banner.square_top_right.yellow": "Һары өҫкө һул майҙан",
  "block.minecraft.banner.straight_cross.black": "Ҡара тәре",
  "block.minecraft.banner.straight_cross.blue": "Күк тәре",
  "block.minecraft.banner.straight_cross.brown": "Көрән тәре",
  "block.minecraft.banner.straight_cross.cyan": "Фирүзә тәре",
  "block.minecraft.banner.straight_cross.gray": "Һоро тәре",
  "block.minecraft.banner.straight_cross.green": "Йәшел тәре",
  "block.minecraft.banner.straight_cross.light_blue": "Зәңгәр тәре",
  "block.minecraft.banner.straight_cross.light_gray": "Аҡһыл һоро тәре",
  "block.minecraft.banner.straight_cross.lime": "Йәшкелт тәре",
  "block.minecraft.banner.straight_cross.magenta": "Ҡуйы ҡыҙыл тәре",
  "block.minecraft.banner.straight_cross.orange": "Хәнәүәт тәре",
  "block.minecraft.banner.straight_cross.pink": "Алһыу тәре",
  "block.minecraft.banner.straight_cross.purple": "Шәмәхә тәре",
  "block.minecraft.banner.straight_cross.red": "Ҡыҙыл тәре",
  "block.minecraft.banner.straight_cross.white": "Аҡ тәре",
  "block.minecraft.banner.straight_cross.yellow": "Һары тәре",
  "block.minecraft.banner.stripe_bottom.black": "Ҡара нигеҙ",
  "block.minecraft.banner.stripe_bottom.blue": "Күк нигеҙ",
  "block.minecraft.banner.stripe_bottom.brown": "Көрән нигеҙ",
  "block.minecraft.banner.stripe_bottom.cyan": "Фирүзә нигеҙ",
  "block.minecraft.banner.stripe_bottom.gray": "Һоро нигеҙ",
  "block.minecraft.banner.stripe_bottom.green": "Йәшел нигеҙ",
  "block.minecraft.banner.stripe_bottom.light_blue": "Зәңгәр нигеҙ",
  "block.minecraft.banner.stripe_bottom.light_gray": "Аҡһыл һоро нигеҙ",
  "block.minecraft.banner.stripe_bottom.lime": "Йәшкелт нигеҙ",
  "block.minecraft.banner.stripe_bottom.magenta": "Ҡуйы ҡыҙыл нигеҙ",
  "block.minecraft.banner.stripe_bottom.orange": "Хәнәүәт нигеҙ",
  "block.minecraft.banner.stripe_bottom.pink": "Алһыу нигеҙ",
  "block.minecraft.banner.stripe_bottom.purple": "Шәмәхә нигеҙ",
  "block.minecraft.banner.stripe_bottom.red": "Ҡыҙыл нигеҙ",
  "block.minecraft.banner.stripe_bottom.white": "Аҡ нигеҙ",
  "block.minecraft.banner.stripe_bottom.yellow": "Һары нигеҙ",
  "block.minecraft.banner.stripe_center.black": "Ҡара бағана",
  "block.minecraft.banner.stripe_center.blue": "Күк бағана",
  "block.minecraft.banner.stripe_center.brown": "Көрән бағана",
  "block.minecraft.banner.stripe_center.cyan": "Фирүзә бағана",
  "block.minecraft.banner.stripe_center.gray": "Һоро бағана",
  "block.minecraft.banner.stripe_center.green": "Йәшел бағана",
  "block.minecraft.banner.stripe_center.light_blue": "Зәңгәр бағана",
  "block.minecraft.banner.stripe_center.light_gray": "Аҡһыл һоро бағана",
  "block.minecraft.banner.stripe_center.lime": "Йәшкелт бағана",
  "block.minecraft.banner.stripe_center.magenta": "Ҡуйы ҡыҙыл бағана",
  "block.minecraft.banner.stripe_center.orange": "Хәнәүәт бағана",
  "block.minecraft.banner.stripe_center.pink": "Алһыу бағана",
  "block.minecraft.banner.stripe_center.purple": "Шәмәхә бағана",
  "block.minecraft.banner.stripe_center.red": "Ҡыҙыл бағана",
  "block.minecraft.banner.stripe_center.white": "Аҡ бағана",
  "block.minecraft.banner.stripe_center.yellow": "Һары бағана",
  "block.minecraft.banner.stripe_downleft.black": "Ҡара һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.blue": "Күк һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.brown": "Көрән һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.cyan": "Фирүзә һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.gray": "Һоро һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.green": "Йәшел һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.light_blue": "Зәңгәр һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.light_gray": "Аҡһыл һоро һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.lime": "Йәшкелт һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.magenta": "Ҡуйы ҡыҙыл һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.orange": "Хәнәүәт һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.pink": "Алһыу һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.purple": "Шәмәхә һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.red": "Ҡыҙыл һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.white": "Аҡ һул ҡайыш",
  "block.minecraft.banner.stripe_downleft.yellow": "Һары һул ҡайыш",
  "block.minecraft.banner.stripe_downright.black": "Ҡара бөгөлөш",
  "block.minecraft.banner.stripe_downright.blue": "Күк бөгөлөш",
  "block.minecraft.banner.stripe_downright.brown": "Көрән бөгөлөш",
  "block.minecraft.banner.stripe_downright.cyan": "Фирүзә бөгөлөш",
  "block.minecraft.banner.stripe_downright.gray": "Һоро бөгөлөш",
  "block.minecraft.banner.stripe_downright.green": "Йәшел бөгөл",
  "block.minecraft.banner.stripe_downright.light_blue": "Зәңгәр бөгөлөш",
  "block.minecraft.banner.stripe_downright.light_gray": "Аҡһыл һоро бөгөлөш",
  "block.minecraft.banner.stripe_downright.lime": "Йәшкелт ҡайыш",
  "block.minecraft.banner.stripe_downright.magenta": "Ҡуйы ҡыҙыл бөгөлөш",
  "block.minecraft.banner.stripe_downright.orange": "Хәнәүәт бөгөлөш",
  "block.minecraft.banner.stripe_downright.pink": "Алһыу бөгөлөш",
  "block.minecraft.banner.stripe_downright.purple": "Шәмәхә бөгөлөш",
  "block.minecraft.banner.stripe_downright.red": "Ҡыҙыл бөгөлөш",
  "block.minecraft.banner.stripe_downright.white": "Аҡ бөгөлөш",
  "block.minecraft.banner.stripe_downright.yellow": "Һары бөгөлөш",
  "block.minecraft.banner.stripe_left.black": "Ҡара уң яҡ бағана",
  "block.minecraft.banner.stripe_left.blue": "Күк уң яҡ бағана",
  "block.minecraft.banner.stripe_left.brown": "Көрән уң яҡ бағана",
  "block.minecraft.banner.stripe_left.cyan": "Фирүзә уң яҡ бағана",
  "block.minecraft.banner.stripe_left.gray": "Һоро уң яҡ бағана",
  "block.minecraft.banner.stripe_left.green": "Йәшел уң яҡ бағана",
  "block.minecraft.banner.stripe_left.light_blue": "Зәңгәр уң яҡ бағана",
  "block.minecraft.banner.stripe_left.light_gray": "Аҡһыл һоро уң яҡ бағана",
  "block.minecraft.banner.stripe_left.lime": "Йәшкелт уң яҡ бағана",
  "block.minecraft.banner.stripe_left.magenta": "Ҡуйы ҡыҙыл уң яҡ бағана",
  "block.minecraft.banner.stripe_left.orange": "Хәнәүәт уң яҡ бағана",
  "block.minecraft.banner.stripe_left.pink": "Алһыу уң яҡ бағана",
  "block.minecraft.banner.stripe_left.purple": "Шәмәхә уң яҡ бағана",
  "block.minecraft.banner.stripe_left.red": "Ҡыҙыл уң яҡ бағана",
  "block.minecraft.banner.stripe_left.white": "Аҡ уң яҡ бағана",
  "block.minecraft.banner.stripe_left.yellow": "Һары уң яҡ бағана",
  "block.minecraft.banner.stripe_middle.black": "Ҡара биллек",
  "block.minecraft.banner.stripe_middle.blue": "Күк биллек",
  "block.minecraft.banner.stripe_middle.brown": "Кәрән биллек",
  "block.minecraft.banner.stripe_middle.cyan": "Фирүзә биллек",
  "block.minecraft.banner.stripe_middle.gray": "Һоро биллек",
  "block.minecraft.banner.stripe_middle.green": "Йәшел биллек",
  "block.minecraft.banner.stripe_middle.light_blue": "Зәңгәр биллек",
  "block.minecraft.banner.stripe_middle.light_gray": "Аҡһыл һоро биллек",
  "block.minecraft.banner.stripe_middle.lime": "Йәшкелт биллек",
  "block.minecraft.banner.stripe_middle.magenta": "Ҡуйы ҡыҙыл биллек",
  "block.minecraft.banner.stripe_middle.orange": "Хәнәүәт биллек",
  "block.minecraft.banner.stripe_middle.pink": "Алһыу биллек",
  "block.minecraft.banner.stripe_middle.purple": "Шәмәхә биллек",
  "block.minecraft.banner.stripe_middle.red": "Ҡыҙыл биллек",
  "block.minecraft.banner.stripe_middle.white": "Аҡ биллек",
  "block.minecraft.banner.stripe_middle.yellow": "Һары биллек",
  "block.minecraft.banner.stripe_right.black": "Ҡара һул яҡ бағана",
  "block.minecraft.banner.stripe_right.blue": "Күк һул яҡ бағана",
  "block.minecraft.banner.stripe_right.brown": "Көрән һул яҡ бағана",
  "block.minecraft.banner.stripe_right.cyan": "Фирүзә һул яҡ бағана",
  "block.minecraft.banner.stripe_right.gray": "Һоро һул яҡ бағана",
  "block.minecraft.banner.stripe_right.green": "Йәшел һул яҡ бағана",
  "block.minecraft.banner.stripe_right.light_blue": "Зәңгәр һул яҡ бағана",
  "block.minecraft.banner.stripe_right.light_gray": "Аҡһыл һоро һул яҡ бағана",
  "block.minecraft.banner.stripe_right.lime": "Йәшкелт һул яҡ бағана",
  "block.minecraft.banner.stripe_right.magenta": "Ҡуйы ҡыҙыл һул яҡ бағана",
  "block.minecraft.banner.stripe_right.orange": "Хәнәүәт һул яҡ бағана",
  "block.minecraft.banner.stripe_right.pink": "Алһыу һул яҡ бағана",
  "block.minecraft.banner.stripe_right.purple": "Шәмәхә һул яҡ бағана",
  "block.minecraft.banner.stripe_right.red": "Ҡыҙыл һул яҡ бағана",
  "block.minecraft.banner.stripe_right.white": "Аҡ һул яҡ бағана",
  "block.minecraft.banner.stripe_right.yellow": "Һары һул яҡ бағана",
  "block.minecraft.banner.stripe_top.black": "Ҡара өҫ",
  "block.minecraft.banner.stripe_top.blue": "Күк өҫ",
  "block.minecraft.banner.stripe_top.brown": "Көрән өҫ",
  "block.minecraft.banner.stripe_top.cyan": "Фирүзә өҫ",
  "block.minecraft.banner.stripe_top.gray": "Һоро өҫ",
  "block.minecraft.banner.stripe_top.green": "Йәшел өҫ",
  "block.minecraft.banner.stripe_top.light_blue": "Зәңгәр өҫ",
  "block.minecraft.banner.stripe_top.light_gray": "Аҡһыл һоро өҫ",
  "block.minecraft.banner.stripe_top.lime": "Йәшкелт өҫ",
  "block.minecraft.banner.stripe_top.magenta": "Ҡуйы ҡыҙыл өҫ",
  "block.minecraft.banner.stripe_top.orange": "Хәнәүәт өҫ",
  "block.minecraft.banner.stripe_top.pink": "Алһыу өҫ",
  "block.minecraft.banner.stripe_top.purple": "Шәмәхә өҫ",
  "block.minecraft.banner.stripe_top.red": "Ҡыҙыл өҫ",
  "block.minecraft.banner.stripe_top.white": "Аҡ өҫ",
  "block.minecraft.banner.stripe_top.yellow": "Һары өҫ",
  "block.minecraft.banner.triangle_bottom.black": "Ҡара шеврон",
  "block.minecraft.banner.triangle_bottom.blue": "Күк шеврон",
  "block.minecraft.banner.triangle_bottom.brown": "Көрән шеврон",
  "block.minecraft.banner.triangle_bottom.cyan": "Фирүзә шеврон",
  "block.minecraft.banner.triangle_bottom.gray": "Һоро шеврон",
  "block.minecraft.banner.triangle_bottom.green": "Йәшел шеврон",
  "block.minecraft.banner.triangle_bottom.light_blue": "Зәңгәр шеврон",
  "block.minecraft.banner.triangle_bottom.light_gray": "Аҡһыл һоро шеврон",
  "block.minecraft.banner.triangle_bottom.lime": "Йәшкелт шеврон",
  "block.minecraft.banner.triangle_bottom.magenta": "Ҡуйы ҡыҙыл шеврон",
  "block.minecraft.banner.triangle_bottom.orange": "Хәнәүәт шеврон",
  "block.minecraft.banner.triangle_bottom.pink": "Алһыу шеврон",
  "block.minecraft.banner.triangle_bottom.purple": "Шәмәхә шеврон",
  "block.minecraft.banner.triangle_bottom.red": "Ҡыҙыл шеврон",
  "block.minecraft.banner.triangle_bottom.white": "Аҡ шеврон",
  "block.minecraft.banner.triangle_bottom.yellow": "Һары шеврон",
  "block.minecraft.banner.triangle_top.black": "Ҡара кире шеврон",
  "block.minecraft.banner.triangle_top.blue": "Күк кире шеврон",
  "block.minecraft.banner.triangle_top.brown": "Көрән кире шеврон",
  "block.minecraft.banner.triangle_top.cyan": "Фирүзә кире шеврон",
  "block.minecraft.banner.triangle_top.gray": "Һоро кире шеврон",
  "block.minecraft.banner.triangle_top.green": "Йәшел кире шеврон",
  "block.minecraft.banner.triangle_top.light_blue": "Зәңгәр кире шеврон",
  "block.minecraft.banner.triangle_top.light_gray": "Аҡһыл һоро кире шеврон",
  "block.minecraft.banner.triangle_top.lime": "Йәшкелт кире шеврон",
  "block.minecraft.banner.triangle_top.magenta": "Ҡуйы ҡыҙыл кире шеврон",
  "block.minecraft.banner.triangle_top.orange": "Хәнәүәт кире шеврон",
  "block.minecraft.banner.triangle_top.pink": "Алһыу кире шеврон",
  "block.minecraft.banner.triangle_top.purple": "Шәмәхә кире шеврон",
  "block.minecraft.banner.triangle_top.red": "Ҡыҙыл кире шеврон",
  "block.minecraft.banner.triangle_top.white": "Аҡ кире шеврон",
  "block.minecraft.banner.triangle_top.yellow": "Һары кире шеврон",
  "block.minecraft.banner.triangles_bottom.black": "Ҡара тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.blue": "Күк тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.brown": "Көрән тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.cyan": "Фирүзә тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.gray": "Һоро тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.green": "Йәшел тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.light_blue": "Зәңгәр тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.light_gray": "Аҡһыл һоро тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.lime": "Йәшкелт тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.magenta": "Ҡуйы ҡыҙыл тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.orange": "Хәнәүәт тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.pink": "Алһыу тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.purple": "Шәмәхә тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.red": "Ҡыҙыл тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.white": "Аҡ тешле нигеҙ",
  "block.minecraft.banner.triangles_bottom.yellow": "Һары тешле нигеҙ",
  "block.minecraft.banner.triangles_top.black": "Ҡара тешле өҫ",
  "block.minecraft.banner.triangles_top.blue": "Күк тешле өҫ",
  "block.minecraft.banner.triangles_top.brown": "Көрән тешле өҫ",
  "block.minecraft.banner.triangles_top.cyan": "Фирүзә тешле өҫ",
  "block.minecraft.banner.triangles_top.gray": "Һоро тешле өҫ",
  "block.minecraft.banner.triangles_top.green": "Йәшел тешле өҫ",
  "block.minecraft.banner.triangles_top.light_blue": "Зәңгәр тешле өҫ",
  "block.minecraft.banner.triangles_top.light_gray": "Аҡһыл һоро тешле өҫ",
  "block.minecraft.banner.triangles_top.lime": "Йәшкелт тешле өҫ",
  "block.minecraft.banner.triangles_top.magenta": "Ҡуйы ҡыҙыл тешле өҫ",
  "block.minecraft.banner.triangles_top.orange": "Хәнәүәт тешле өҫ",
  "block.minecraft.banner.triangles_top.pink": "Алһыу тешле өҫ",
  "block.minecraft.banner.triangles_top.purple": "Шәмәхә тешле өҫ",
  "block.minecraft.banner.triangles_top.red": "Ҡыҙыл тешле өҫ",
  "block.minecraft.banner.triangles_top.white": "Аҡ тешле өҫ",
  "block.minecraft.banner.triangles_top.yellow": "Һары тешле өҫ",
  "block.minecraft.barrel": "Мискә",
  "block.minecraft.barrier": "Тотҡарлыҡ",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Маяҡ",
  "block.minecraft.beacon.primary": "Төп йоғонто",
  "block.minecraft.beacon.secondary": "Икенсе йоғонто",
  "block.minecraft.bed.no_sleep": "Һеҙ төндә лә йәшен ваҡытында ғына йоҡлай алаһығыҙ",
  "block.minecraft.bed.not_safe": "Ҡурҡыныслыҡтар яндарығыҙҙа йөрөгәнсе, һеҙ йөҡлай алмайһығыҙ",
  "block.minecraft.bed.obstructed": "Был карауат төҙөлгән",
  "block.minecraft.bed.occupied": "Был карауат буш түгел",
  "block.minecraft.bed.too_far_away": "Карауат бик алыҫ тора, һеҙ йоҡлай алмайһығыҙ",
  "block.minecraft.bedrock": "Бедрок",
  "block.minecraft.bee_nest": "Бал ҡорто ояһы",
  "block.minecraft.beehive": "Умарта",
  "block.minecraft.beetroots": "Сөгөлдөр",
  "block.minecraft.bell": "Ҡаңғырау",
  "block.minecraft.big_dripleaf": "Ҙур тамсыяпраҡ",
  "block.minecraft.big_dripleaf_stem": "Ҙур тамсыяпраҡ һабағы",
  "block.minecraft.birch_button": "Ҡайын төймәһе",
  "block.minecraft.birch_door": "Ҡайын ишеге",
  "block.minecraft.birch_fence": "Ҡайын ҡоймаһы",
  "block.minecraft.birch_fence_gate": "Ҡайын ҡапҡаһы",
  "block.minecraft.birch_hanging_sign": "Ҡайын алтаҡта",
  "block.minecraft.birch_leaves": "Ҡайын япраҡтары",
  "block.minecraft.birch_log": "Ҡайын бүрәнәһе",
  "block.minecraft.birch_planks": "Ҡайын таҡталары",
  "block.minecraft.birch_pressure_plate": "Ҡайын ҡыҫым плитаһы",
  "block.minecraft.birch_sapling": "Ҡайын үҫентеһе",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Ҡайын яҙмаҡсалығы",
  "block.minecraft.birch_slab": "Ҡайын плитаһы",
  "block.minecraft.birch_stairs": "Ҡайын баҫҡыстары",
  "block.minecraft.birch_trapdoor": "Ҡайын люгы",
  "block.minecraft.birch_wall_hanging_sign": "Ҡайын диуар алтаҡтаһы",
  "block.minecraft.birch_wall_sign": "Ҡайын диуар билдәһе",
  "block.minecraft.birch_wood": "Ҡайын",
  "block.minecraft.black_banner": "Ҡара байраҡ",
  "block.minecraft.black_bed": "Ҡара карауат",
  "block.minecraft.black_candle": "Ҡара шәм",
  "block.minecraft.black_candle_cake": "Ҡара шәм менән торт",
  "block.minecraft.black_carpet": "Ҡара келәм",
  "block.minecraft.black_concrete": "Ҡара бетон",
  "block.minecraft.black_concrete_powder": "Ҡара ҡоро бетон",
  "block.minecraft.black_glazed_terracotta": "Ҡара ялтырауыҡлы яндырығашы",
  "block.minecraft.black_shulker_box": "Ҡара шалкер ҡумтаһы",
  "block.minecraft.black_stained_glass": "Ҡара быяла",
  "block.minecraft.black_stained_glass_pane": "Ҡара биҙәкле быяла",
  "block.minecraft.black_terracotta": "Ҡара яндырығашы",
  "block.minecraft.black_wool": "Ҡара йөн",
  "block.minecraft.blackstone": "Ҡараташ",
  "block.minecraft.blackstone_slab": "Ҡараташ плитаһы",
  "block.minecraft.blackstone_stairs": "Ҡараташ баҫҡыстары",
  "block.minecraft.blackstone_wall": "Ҡараташ ҡоймаһы",
  "block.minecraft.blast_furnace": "Иреткес мейес",
  "block.minecraft.blue_banner": "Күк байраҡ",
  "block.minecraft.blue_bed": "Күк карауат",
  "block.minecraft.blue_candle": "Күк шәм",
  "block.minecraft.blue_candle_cake": "Күк шәм менән торт",
  "block.minecraft.blue_carpet": "Күк келәм",
  "block.minecraft.blue_concrete": "Күк бетон",
  "block.minecraft.blue_concrete_powder": "Күк ҡоро бетон",
  "block.minecraft.blue_glazed_terracotta": "Күк ялтырауыҡлы яндырығашы",
  "block.minecraft.blue_ice": "Күк боҙ",
  "block.minecraft.blue_orchid": "Күк орхидея",
  "block.minecraft.blue_shulker_box": "Күк шалкер ҡумтаһы",
  "block.minecraft.blue_stained_glass": "Күк быяла",
  "block.minecraft.blue_stained_glass_pane": "Күк биҙәкле быяла",
  "block.minecraft.blue_terracotta": "Күк яндырығашы",
  "block.minecraft.blue_wool": "Күк йөн",
  "block.minecraft.bone_block": "Һөйәк блогы",
  "block.minecraft.bookshelf": "Китап шүрлеге",
  "block.minecraft.brain_coral": "Мейе мәрйен",
  "block.minecraft.brain_coral_block": "Мейе мәрйен блогы",
  "block.minecraft.brain_coral_fan": "Елпеүесле мейе мәрйен",
  "block.minecraft.brain_coral_wall_fan": "Ятма елпеүесле мейе мәрйен",
  "block.minecraft.brewing_stand": "Төнәтмә ҡайнатыу терәге",
  "block.minecraft.brick_slab": "Кирбес плитаһы",
  "block.minecraft.brick_stairs": "Кирбес баҫҡыстары",
  "block.minecraft.brick_wall": "Кирбес ҡоймаһы",
  "block.minecraft.bricks": "Кирбестәр",
  "block.minecraft.brown_banner": "Көрән байраҡ",
  "block.minecraft.brown_bed": "Көрән карауат",
  "block.minecraft.brown_candle": "Көрән шәм",
  "block.minecraft.brown_candle_cake": "Көрән шәм менән торт",
  "block.minecraft.brown_carpet": "Көрән келәм",
  "block.minecraft.brown_concrete": "Көрән бетон",
  "block.minecraft.brown_concrete_powder": "Көрән ҡоро бетон",
  "block.minecraft.brown_glazed_terracotta": "Көрән ялтырауыҡлы яндырығашы",
  "block.minecraft.brown_mushroom": "Көрән бәшмәк",
  "block.minecraft.brown_mushroom_block": "Көрән бәшмәк блогы",
  "block.minecraft.brown_shulker_box": "Көрән шалкер ҡумтаһы",
  "block.minecraft.brown_stained_glass": "Көрән быяла",
  "block.minecraft.brown_stained_glass_pane": "Көрән биҙәкле быяла",
  "block.minecraft.brown_terracotta": "Көрән яндырығашы",
  "block.minecraft.brown_wool": "Көрән йөн",
  "block.minecraft.bubble_column": "Күперткеләрҙең терәге",
  "block.minecraft.bubble_coral": "Ҡыуыҡлы мәрйен",
  "block.minecraft.bubble_coral_block": "Күбек мәрйен блогы",
  "block.minecraft.bubble_coral_fan": "Елпеүесле ҡыуыҡлы мәрйен",
  "block.minecraft.bubble_coral_wall_fan": "Ятма елпеүесле ҡыуыҡлыҡ мәрйен",
  "block.minecraft.budding_amethyst": "Бөрө ебәреүсе аметист",
  "block.minecraft.bush": "Ҡыуаҡ",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кактус сәскәһе",
  "block.minecraft.cake": "Торт",
  "block.minecraft.calcite": "Кальцит",
  "block.minecraft.calibrated_sculk_sensor": "Калибрланған скалк сенсор",
  "block.minecraft.campfire": "Усаҡ",
  "block.minecraft.candle": "Шәм",
  "block.minecraft.candle_cake": "Шәм менән торт",
  "block.minecraft.carrots": "Кишер",
  "block.minecraft.cartography_table": "Картограф өҫтәле",
  "block.minecraft.carved_pumpkin": "Киҫелгән ҡабаҡ",
  "block.minecraft.cauldron": "Ҡаҙан",
  "block.minecraft.cave_air": "Мәмерйә һауаһы",
  "block.minecraft.cave_vines": "Мәмерйә талдары",
  "block.minecraft.cave_vines_plant": "Мәмерйә талы һабағы",
  "block.minecraft.chain": "Сынйыр",
  "block.minecraft.chain_command_block": "Эҙмә-эҙлекле бойороҡ блогы",
  "block.minecraft.cherry_button": "Сейә ағас төймәһе",
  "block.minecraft.cherry_door": "Сейә ағас ишеге",
  "block.minecraft.cherry_fence": "Сейә ағас ҡоймаһы",
  "block.minecraft.cherry_fence_gate": "Сейә ағас ҡапҡаһы",
  "block.minecraft.cherry_hanging_sign": "Сейә ағас алтаҡтаһы",
  "block.minecraft.cherry_leaves": "Сейә ағас япраҡтары",
  "block.minecraft.cherry_log": "Сейә ағас бүрәнәһе",
  "block.minecraft.cherry_planks": "Сейә ағас таҡталары",
  "block.minecraft.cherry_pressure_plate": "Сейә ағас ҡыҫым плитаһы",
  "block.minecraft.cherry_sapling": "Сейә ағас үҫентеһе",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Сейә ағас яҙмаҡсалығы",
  "block.minecraft.cherry_slab": "Сейә ағас плитаһы",
  "block.minecraft.cherry_stairs": "Сейә ағас баҫҡыстары",
  "block.minecraft.cherry_trapdoor": "Сейә ағас люгы",
  "block.minecraft.cherry_wall_hanging_sign": "Сейә ағас диуар алтаҡтаһы",
  "block.minecraft.cherry_wall_sign": "Сейә ағас диуар билдәһе",
  "block.minecraft.cherry_wood": "Сейә ағас",
  "block.minecraft.chest": "Һандыҡ",
  "block.minecraft.chipped_anvil": "Боҙылған һандал",
  "block.minecraft.chiseled_bookshelf": "Һырланған китап шүрлеге",
  "block.minecraft.chiseled_copper": "Семәрле баҡыр",
  "block.minecraft.chiseled_deepslate": "Һырланған һәүерташ",
  "block.minecraft.chiseled_nether_bricks": "Һырланған неҙер кирбестәре",
  "block.minecraft.chiseled_polished_blackstone": "Һырланған шымартылған ҡараташ",
  "block.minecraft.chiseled_quartz_block": "Һырланған кварц блогы",
  "block.minecraft.chiseled_red_sandstone": "Һырланған ҡыҙыл ҡомташ",
  "block.minecraft.chiseled_resin_bricks": "Һырланған ыҫмала кирбестәре",
  "block.minecraft.chiseled_sandstone": "Һырланған ҡомташ",
  "block.minecraft.chiseled_stone_bricks": "Һырланған таш кирбестәре",
  "block.minecraft.chiseled_tuff": "Семәрле туф",
  "block.minecraft.chiseled_tuff_bricks": "Һырланған туф кирбестәре",
  "block.minecraft.chorus_flower": "Хорус сәскәһе",
  "block.minecraft.chorus_plant": "Хорус",
  "block.minecraft.clay": "Балсыҡ",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Күмер ҡорама",
  "block.minecraft.coal_ore": "Ташкүмер",
  "block.minecraft.coarse_dirt": "Ташлы тупраҡ",
  "block.minecraft.cobbled_deepslate": "Йоморолған һәүерташ",
  "block.minecraft.cobbled_deepslate_slab": "Йоморолған һәүерташ плитаһы",
  "block.minecraft.cobbled_deepslate_stairs": "Йоморолған һәүерташ баҫҡыстары",
  "block.minecraft.cobbled_deepslate_wall": "Йоморолған һәүерташ ҡоймаһы",
  "block.minecraft.cobblestone": "Һуйырташ",
  "block.minecraft.cobblestone_slab": "Һуйырташ плитаһы",
  "block.minecraft.cobblestone_stairs": "Һуйырташ баҫҡыстары",
  "block.minecraft.cobblestone_wall": "Һуйырташ ҡоймаһы",
  "block.minecraft.cobweb": "Үрмәксе ауы",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Бойороҡ блогы",
  "block.minecraft.comparator": "Редстоун сағыштырғысы",
  "block.minecraft.composter": "Серемдек",
  "block.minecraft.conduit": "Диңгеҙ сығанағы",
  "block.minecraft.copper_bars": "Баҡыр талдар",
  "block.minecraft.copper_block": "Баҡыр блогы",
  "block.minecraft.copper_bulb": "Баҡыр лампаһы",
  "block.minecraft.copper_chain": "Баҡыр сынйыр",
  "block.minecraft.copper_chest": "Баҡыр һандыҡ",
  "block.minecraft.copper_door": "Баҡыр ишек",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Баҡыр рәшәткә",
  "block.minecraft.copper_lantern": "Баҡыр күк",
  "block.minecraft.copper_ore": "Баҡыр мәғдәне",
  "block.minecraft.copper_torch": "Баҡыр сыраҡ",
  "block.minecraft.copper_trapdoor": "Баҡыр люк",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Зәңгәр сәскә",
  "block.minecraft.cracked_deepslate_bricks": "Ярылған һәүерташ кирбестәре",
  "block.minecraft.cracked_deepslate_tiles": "Ярылған һәүерташ шаҡмағы",
  "block.minecraft.cracked_nether_bricks": "Ярылған неҙер кирбестәре",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ярылған шымартылған ҡараташ кирбестәре",
  "block.minecraft.cracked_stone_bricks": "Ярылған таш кирбестәре",
  "block.minecraft.crafter": "Яһаусы",
  "block.minecraft.crafting_table": "Эшкәртеү өҫтәле",
  "block.minecraft.creaking_heart": "Шағыр-шоғор йөрәге",
  "block.minecraft.creeper_head": "Крипер башы",
  "block.minecraft.creeper_wall_head": "Диуарҙағы крипер башы",
  "block.minecraft.crimson_button": "Бурлат төймә",
  "block.minecraft.crimson_door": "Бурлат ишек",
  "block.minecraft.crimson_fence": "Бурлат ҡойма",
  "block.minecraft.crimson_fence_gate": "Бурлат ҡапҡа",
  "block.minecraft.crimson_fungus": "Булат бәшмәк",
  "block.minecraft.crimson_hanging_sign": "Бурлат алтаҡта",
  "block.minecraft.crimson_hyphae": "Бурлат һифалары",
  "block.minecraft.crimson_nylium": "Бурлат нилий",
  "block.minecraft.crimson_planks": "Бурлат таҡталары",
  "block.minecraft.crimson_pressure_plate": "Бурлат ҡыҫым плитаһы",
  "block.minecraft.crimson_roots": "Бурлат тамырҙар",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Бурлат яҙмаҡсалығы",
  "block.minecraft.crimson_slab": "Бурлат плитаһы",
  "block.minecraft.crimson_stairs": "Бурлат баҫҡыстар",
  "block.minecraft.crimson_stem": "Бурлат һабағы",
  "block.minecraft.crimson_trapdoor": "Бурлат люгы",
  "block.minecraft.crimson_wall_hanging_sign": "Бурлат диуар алтаҡтаһы",
  "block.minecraft.crimson_wall_sign": "Бурлат диуар алтаҡтаһы",
  "block.minecraft.crying_obsidian": "Илау обсидианы",
  "block.minecraft.cut_copper": "Һырлы баҡыр",
  "block.minecraft.cut_copper_slab": "Һырлы баҡыр плитаһы",
  "block.minecraft.cut_copper_stairs": "Һырлы баҡыр баҫҡыстары",
  "block.minecraft.cut_red_sandstone": "Шыма ҡыҙыл ҡомташ",
  "block.minecraft.cut_red_sandstone_slab": "Шыма ҡыҙыл ҡомташ плитаһы",
  "block.minecraft.cut_sandstone": "Шыма ҡомташ",
  "block.minecraft.cut_sandstone_slab": "Шыма ҡомташ плитаһы",
  "block.minecraft.cyan_banner": "Фирүзә байраҡ",
  "block.minecraft.cyan_bed": "Фирүзә карауат",
  "block.minecraft.cyan_candle": "Фирүзә шәм",
  "block.minecraft.cyan_candle_cake": "Фирүзә шәм менән торт",
  "block.minecraft.cyan_carpet": "Фирүзә келәм",
  "block.minecraft.cyan_concrete": "Фирүзә бетон",
  "block.minecraft.cyan_concrete_powder": "Фирүзә ҡоро бетон",
  "block.minecraft.cyan_glazed_terracotta": "Фирүзә ялтырауыҡлы яндырығашы",
  "block.minecraft.cyan_shulker_box": "Фирүзә шалкер ҡумтаһы",
  "block.minecraft.cyan_stained_glass": "Фирүзә быяла",
  "block.minecraft.cyan_stained_glass_pane": "Фирүзә биҙәкле быяла",
  "block.minecraft.cyan_terracotta": "Фирүзә яндырығашы",
  "block.minecraft.cyan_wool": "Фирүзә йөн",
  "block.minecraft.damaged_anvil": "Ватылған һандал",
  "block.minecraft.dandelion": "Бәпембә",
  "block.minecraft.dark_oak_button": "Ҡара имән төймә",
  "block.minecraft.dark_oak_door": "Ҡара имән ишеге",
  "block.minecraft.dark_oak_fence": "Ҡара имән ҡоймаһы",
  "block.minecraft.dark_oak_fence_gate": "Ҡара имән ҡапҡаһы",
  "block.minecraft.dark_oak_hanging_sign": "Ҡара имән алтаҡта",
  "block.minecraft.dark_oak_leaves": "Ҡара имән япраҡтары",
  "block.minecraft.dark_oak_log": "Ҡара имән бүрәнәһе",
  "block.minecraft.dark_oak_planks": "Ҡара имән таҡталары",
  "block.minecraft.dark_oak_pressure_plate": "Ҡара имән ҡыҫым плитаһы",
  "block.minecraft.dark_oak_sapling": "Ҡара имән үҫентеһе",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Ҡара имән яҙмаҡсалығы",
  "block.minecraft.dark_oak_slab": "Ҡара имән плитаһы",
  "block.minecraft.dark_oak_stairs": "Ҡара имән баҫҡыстары",
  "block.minecraft.dark_oak_trapdoor": "Ҡара имән люгы",
  "block.minecraft.dark_oak_wall_hanging_sign": "Ҡара имән диуар алтаҡтаһы",
  "block.minecraft.dark_oak_wall_sign": "Ҡара имән диуар билдәһе",
  "block.minecraft.dark_oak_wood": "Ҡара имән",
  "block.minecraft.dark_prismarine": "Ҡара призмарин",
  "block.minecraft.dark_prismarine_slab": "Ҡара призмарин плитаһы",
  "block.minecraft.dark_prismarine_stairs": "Ҡара призмарин баҫҡыстары",
  "block.minecraft.daylight_detector": "Көндөҙгө яҡтылыҡ датчигы",
  "block.minecraft.dead_brain_coral": "Үле мейе мәрйен",
  "block.minecraft.dead_brain_coral_block": "Үле мейе мәрйен блогы",
  "block.minecraft.dead_brain_coral_fan": "Үле елпеүесле мейе мәрйен",
  "block.minecraft.dead_brain_coral_wall_fan": "Ятма үле елпеүесле мейе мәрйен",
  "block.minecraft.dead_bubble_coral": "Үле ҡыуыҡлы мәрйен",
  "block.minecraft.dead_bubble_coral_block": "Үле күбек мәрйен блогы",
  "block.minecraft.dead_bubble_coral_fan": "Үле елпеүесле ҡыуыҡлы мәрйен",
  "block.minecraft.dead_bubble_coral_wall_fan": "Ятма үле елпеүесле ҡыуыҡлы мәрйен",
  "block.minecraft.dead_bush": "Үле ҡыуаҡ",
  "block.minecraft.dead_fire_coral": "Үле утлы мәрйен",
  "block.minecraft.dead_fire_coral_block": "Үле утлы мәрйен блогы",
  "block.minecraft.dead_fire_coral_fan": "Үле елпеүесле утлыҡ мәрйен",
  "block.minecraft.dead_fire_coral_wall_fan": "Ятма үле елпеүесле утлы мәрйен",
  "block.minecraft.dead_horn_coral": "Үле мөгөҙлө мәрйен",
  "block.minecraft.dead_horn_coral_block": "Үле мөгөҙлө мәрйен блогы",
  "block.minecraft.dead_horn_coral_fan": "Үле елпеүесле мөгөҙлө мәрйен",
  "block.minecraft.dead_horn_coral_wall_fan": "Ятма үле елпеүесле мөгөҙлө мәрйен",
  "block.minecraft.dead_tube_coral": "Үле көпшәк мәрйен",
  "block.minecraft.dead_tube_coral_block": "Үле көпшәк мәрйен блогы",
  "block.minecraft.dead_tube_coral_fan": "Үле елпеүесле көпшәле мәрйен",
  "block.minecraft.dead_tube_coral_wall_fan": "Ятма үле елпеүесле көпшәле мәрйен",
  "block.minecraft.decorated_pot": "Декоратив сүлмәге",
  "block.minecraft.deepslate": "Һәүерташ",
  "block.minecraft.deepslate_brick_slab": "Һәүерташ кирбес плитаһы",
  "block.minecraft.deepslate_brick_stairs": "Һәүерташ кирбес баҫҡыстары",
  "block.minecraft.deepslate_brick_wall": "Һәүерташ кирбес ҡоймаһы",
  "block.minecraft.deepslate_bricks": "Һәүерташ кирбестәре",
  "block.minecraft.deepslate_coal_ore": "Һәүерташ күмере мәғдәне",
  "block.minecraft.deepslate_copper_ore": "Һәүерташ баҡыры мәғдәне",
  "block.minecraft.deepslate_diamond_ore": "Һәүерташ алмасы мәғдәне",
  "block.minecraft.deepslate_emerald_ore": "Һәүерташ зөбәржәте мәғдәне",
  "block.minecraft.deepslate_gold_ore": "Тәрәндәге һәүерташ алтын мәғдәне",
  "block.minecraft.deepslate_iron_ore": "Тәрәндәге һәүерташ тимер мәғдәне",
  "block.minecraft.deepslate_lapis_ore": "Һәүерташ лазуриты мәғдәне",
  "block.minecraft.deepslate_redstone_ore": "Һәүерташ редстоуны мәғдәне",
  "block.minecraft.deepslate_tile_slab": "Һәүерташ шаҡмағы плитаһы",
  "block.minecraft.deepslate_tile_stairs": "Һәүерташ шаҡмағы баҫҡыстары",
  "block.minecraft.deepslate_tile_wall": "Һәүерташ шаҡмағы ҡоймаһы",
  "block.minecraft.deepslate_tiles": "Һәүерташ шаҡмағы",
  "block.minecraft.detector_rail": "Детекторлы тимер юл",
  "block.minecraft.diamond_block": "Алмас ҡорама",
  "block.minecraft.diamond_ore": "Алмас мәғдәне",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Диорит плитаһы",
  "block.minecraft.diorite_stairs": "Диорит баҫҡыстары",
  "block.minecraft.diorite_wall": "Диорит ҡоймаһы",
  "block.minecraft.dirt": "Тупраҡ",
  "block.minecraft.dirt_path": "Һуҡмаҡ",
  "block.minecraft.dispenser": "Таратыусы",
  "block.minecraft.dragon_egg": "Аждаһа йомортҡаһы",
  "block.minecraft.dragon_head": "Аждаһа башы",
  "block.minecraft.dragon_wall_head": "Диуарҙағы аждаһа башы",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Кипкән диңгеҙ кәбеҫтәнең өйөмө",
  "block.minecraft.dripstone_block": "Тамсылыҡ блогы",
  "block.minecraft.dropper": "Ташлатҡыс",
  "block.minecraft.emerald_block": "Зөбәржәт блогы",
  "block.minecraft.emerald_ore": "Зөбәржәт мәғдәне",
  "block.minecraft.enchanting_table": "Сихырлау өҫтәле",
  "block.minecraft.end_gateway": "Энд ҡапҡаһы",
  "block.minecraft.end_portal": "Энд порталы",
  "block.minecraft.end_portal_frame": "Энд порталы ҡыҫанғы",
  "block.minecraft.end_rod": "Энд үҙәге",
  "block.minecraft.end_stone": "Эндерташ",
  "block.minecraft.end_stone_brick_slab": "Эндерташ кирбес плитаһы",
  "block.minecraft.end_stone_brick_stairs": "Эндерташ кирбестәр баҫҡыстары",
  "block.minecraft.end_stone_brick_wall": "Эндерташ кирбес ҡоймаһы",
  "block.minecraft.end_stone_bricks": "Эндерташ кирбестәре",
  "block.minecraft.ender_chest": "Эндер-һандыҡ",
  "block.minecraft.exposed_chiseled_copper": "Ҡарайған семәрле баҡыр",
  "block.minecraft.exposed_copper": "Ҡарайған баҡыр",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Ҡарайған баҡыр лампаһы",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Ҡарайған баҡыр ишек",
  "block.minecraft.exposed_copper_golem_statue": "Ҡараланған баҡыр голем һәйкәле",
  "block.minecraft.exposed_copper_grate": "Ҡарайған баҡыр рәшәткә",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Ҡарайған баҡыр люк",
  "block.minecraft.exposed_cut_copper": "Ҡарайған һырлы баҡыр",
  "block.minecraft.exposed_cut_copper_slab": "Ҡарайған һырлы баҡыр плитаһы",
  "block.minecraft.exposed_cut_copper_stairs": "Ҡарайған һырлы баҡыр баҫҡыстары",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Һөрөлгән ер",
  "block.minecraft.fern": "Ҡаҙаяҡ",
  "block.minecraft.fire": "Ут",
  "block.minecraft.fire_coral": "Утлы мәрйен",
  "block.minecraft.fire_coral_block": "Ут мәрйен блогы",
  "block.minecraft.fire_coral_fan": "Елпеүесле утлы мәрйен",
  "block.minecraft.fire_coral_wall_fan": "Ятма елпеүесле утлыҡ мәрйен",
  "block.minecraft.firefly_bush": "Баҙлауыҡтар менән ҡыуаҡ",
  "block.minecraft.fletching_table": "Йәйәүсенең өҫтәле",
  "block.minecraft.flower_pot": "Сәскә сүлмәге",
  "block.minecraft.flowering_azalea": "Гөлләгән азалия",
  "block.minecraft.flowering_azalea_leaves": "Гөлләгән азалия япраҡтары",
  "block.minecraft.frogspawn": "Телмәрйен ыуылдырығы",
  "block.minecraft.frosted_ice": "Ирегән боҙ",
  "block.minecraft.furnace": "Мейес",
  "block.minecraft.gilded_blackstone": "Алтынланған ҡараташ",
  "block.minecraft.glass": "Быяла",
  "block.minecraft.glass_pane": "Биҙәкле быяла",
  "block.minecraft.glow_lichen": "Яҡты мүк",
  "block.minecraft.glowstone": "Яҡтыташ",
  "block.minecraft.gold_block": "Алтын блогы",
  "block.minecraft.gold_ore": "Алтын мәғдәне",
  "block.minecraft.golden_dandelion": "Алтын бәпембә",
  "block.minecraft.granite": "Гранит",
  "block.minecraft.granite_slab": "Гранит плитаһы",
  "block.minecraft.granite_stairs": "Гранит баҫҡыстары",
  "block.minecraft.granite_wall": "Гранит ҡоймаһы",
  "block.minecraft.grass": "Үлән",
  "block.minecraft.grass_block": "Кәҫ",
  "block.minecraft.gravel": "Ҡырсынташ",
  "block.minecraft.gray_banner": "Һоро байраҡ",
  "block.minecraft.gray_bed": "Һоро карауат",
  "block.minecraft.gray_candle": "Һоро шәм",
  "block.minecraft.gray_candle_cake": "Һоро шәм менән торт",
  "block.minecraft.gray_carpet": "Һоро келәм",
  "block.minecraft.gray_concrete": "Һоро бетон",
  "block.minecraft.gray_concrete_powder": "Һоро ҡоро бетон",
  "block.minecraft.gray_glazed_terracotta": "Һоро ялтырауыҡлы яндырығашы",
  "block.minecraft.gray_shulker_box": "Һоро шалкер ҡумтаһы",
  "block.minecraft.gray_stained_glass": "Һоро быяла",
  "block.minecraft.gray_stained_glass_pane": "Һоро биҙәкле быяла",
  "block.minecraft.gray_terracotta": "Һоро яндырығашы",
  "block.minecraft.gray_wool": "Һоро йөн",
  "block.minecraft.green_banner": "Йәшел байраҡ",
  "block.minecraft.green_bed": "Йәшел карауат",
  "block.minecraft.green_candle": "Йәшел шәм",
  "block.minecraft.green_candle_cake": "Йәшел шәм менән торт",
  "block.minecraft.green_carpet": "Йәшел келәм",
  "block.minecraft.green_concrete": "Йәшел бетон",
  "block.minecraft.green_concrete_powder": "Йәшел ҡоро бетон",
  "block.minecraft.green_glazed_terracotta": "Йәшел ялтырауыҡлы яндырығашы",
  "block.minecraft.green_shulker_box": "Йәшел шалкер ҡумтаһы",
  "block.minecraft.green_stained_glass": "Йәшел быяла",
  "block.minecraft.green_stained_glass_pane": "Йәшел биҙәкле быяла",
  "block.minecraft.green_terracotta": "Йәшел яндырығашы",
  "block.minecraft.green_wool": "Йәшел йөн",
  "block.minecraft.grindstone": "Сар",
  "block.minecraft.hanging_roots": "Һалбыр тамырҙар",
  "block.minecraft.hay_block": "Бесән көлтәһе",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Ауыр йөклө ауырлыҡ плитаһы",
  "block.minecraft.honey_block": "Бал блогы",
  "block.minecraft.honeycomb_block": "Бал ҡортоларҙың кәрәҙ блогы",
  "block.minecraft.hopper": "Буранка",
  "block.minecraft.horn_coral": "Мөгөҙлө мәрйен",
  "block.minecraft.horn_coral_block": "Мөгөҙлө мәрйен блогы",
  "block.minecraft.horn_coral_fan": "Елпеүесле мөгөҙлө мәрйен",
  "block.minecraft.horn_coral_wall_fan": "Ятма елпеүесле мөгөҙлө мәрйен",
  "block.minecraft.ice": "Боҙ",
  "block.minecraft.infested_chiseled_stone_bricks": "Ағыулы һырланған таш кирбестәре",
  "block.minecraft.infested_cobblestone": "Ағыулы һуйырташ",
  "block.minecraft.infested_cracked_stone_bricks": "Ағыулы ярылған таш кирбестәре",
  "block.minecraft.infested_deepslate": "Ағыулы һәүерташ",
  "block.minecraft.infested_mossy_stone_bricks": "Ағыулы мүкләнгән таш кирбестәре",
  "block.minecraft.infested_stone": "Ағыулы таш",
  "block.minecraft.infested_stone_bricks": "Ағыулы таш кирбестәре",
  "block.minecraft.iron_bars": "Тимер талдар",
  "block.minecraft.iron_block": "Тимер блогы",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Тимер ишек",
  "block.minecraft.iron_ore": "Тимер мәғдәне",
  "block.minecraft.iron_trapdoor": "Тимер люгы",
  "block.minecraft.jack_o_lantern": "Джек күге",
  "block.minecraft.jigsaw": "Пазл",
  "block.minecraft.jukebox": "Уйнатҡыс",
  "block.minecraft.jungle_button": "Тропик ағас төймәһе",
  "block.minecraft.jungle_door": "Тропик ағас ишеге",
  "block.minecraft.jungle_fence": "Тропик ағас ҡоймаһы",
  "block.minecraft.jungle_fence_gate": "Тропик ағас ҡапҡаһы",
  "block.minecraft.jungle_hanging_sign": "Тропик ағас алтаҡта",
  "block.minecraft.jungle_leaves": "Тропик ағас япраҡтары",
  "block.minecraft.jungle_log": "Тропик ағас бүрәнәһе",
  "block.minecraft.jungle_planks": "Тропик ағас таҡталары",
  "block.minecraft.jungle_pressure_plate": "Тропик ағас ҡыҫым плитаһы",
  "block.minecraft.jungle_sapling": "Тропик ағас үҫентеһе",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Тропик ағас яҙмаҡсалығы",
  "block.minecraft.jungle_slab": "Тропик ағас плитаһы",
  "block.minecraft.jungle_stairs": "Тропик ағас баҫҡыстары",
  "block.minecraft.jungle_trapdoor": "Тропик ағас люгы",
  "block.minecraft.jungle_wall_hanging_sign": "Тропик ағас диуар алтаҡтаһы",
  "block.minecraft.jungle_wall_sign": "Тропик ағас диуар билдәһе",
  "block.minecraft.jungle_wood": "Тропик ағасы",
  "block.minecraft.kelp": "Диңгеҙ кәбеҫтәһе",
  "block.minecraft.kelp_plant": "Диңгеҙ кәбеҫтәнең һабағы",
  "block.minecraft.ladder": "Баҫҡыс",
  "block.minecraft.lantern": "Күк",
  "block.minecraft.lapis_block": "Лазурит блогы",
  "block.minecraft.lapis_ore": "Лазурит мәғдәне",
  "block.minecraft.large_amethyst_bud": "Эре аметист бөрөһө",
  "block.minecraft.large_fern": "Эре ҡаҙаяҡ",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Лава менән ҡаҙан",
  "block.minecraft.leaf_litter": "Ҡоро япраҡтар",
  "block.minecraft.lectern": "Кафедра",
  "block.minecraft.lever": "Һалмауыр",
  "block.minecraft.light": "Яҡтылыҡ",
  "block.minecraft.light_blue_banner": "Зәңгәр байраҡ",
  "block.minecraft.light_blue_bed": "Зәңгәр карауат",
  "block.minecraft.light_blue_candle": "Зәңгәр шәм",
  "block.minecraft.light_blue_candle_cake": "Зәңгәр шәм менән торт",
  "block.minecraft.light_blue_carpet": "Зәңгәр келәм",
  "block.minecraft.light_blue_concrete": "Зәңгәр бетон",
  "block.minecraft.light_blue_concrete_powder": "Зәңгәр ҡоро бетон",
  "block.minecraft.light_blue_glazed_terracotta": "Зәңгәр ялтырауыҡлы яндырығашы",
  "block.minecraft.light_blue_shulker_box": "Зәңгәр шалкер ҡумтаһы",
  "block.minecraft.light_blue_stained_glass": "Зәңгәр быяла",
  "block.minecraft.light_blue_stained_glass_pane": "Зәңгәр биҙәкле быяла",
  "block.minecraft.light_blue_terracotta": "Зәңгәр яндырығашы",
  "block.minecraft.light_blue_wool": "Зәңгәр йөн",
  "block.minecraft.light_gray_banner": "Аҡһыл һоро байраҡ",
  "block.minecraft.light_gray_bed": "Аҡһыл һоро карауат",
  "block.minecraft.light_gray_candle": "Аҡһыл һоро шәм",
  "block.minecraft.light_gray_candle_cake": "Аҡһыл һоро шәм менән торт",
  "block.minecraft.light_gray_carpet": "Аҡһыл һоро келәм",
  "block.minecraft.light_gray_concrete": "Аҡһыл һоро бетон",
  "block.minecraft.light_gray_concrete_powder": "Аҡһыл һоро ҡоро бетон",
  "block.minecraft.light_gray_glazed_terracotta": "Аҡһыл һоро ялтырауыҡлы яндырығашы",
  "block.minecraft.light_gray_shulker_box": "Аҡһыл һоро шалкер ҡумтаһы",
  "block.minecraft.light_gray_stained_glass": "Аҡһыл һоро быяла",
  "block.minecraft.light_gray_stained_glass_pane": "Аҡһыл һоро биҙәкле быяла",
  "block.minecraft.light_gray_terracotta": "Аҡһыл һоро яндырығашы",
  "block.minecraft.light_gray_wool": "Аҡһыл һоро йөн",
  "block.minecraft.light_weighted_pressure_plate": "Ауырлыҡ плитаһы",
  "block.minecraft.lightning_rod": "Йәшен ҡайтарғыс",
  "block.minecraft.lilac": "Күксин",
  "block.minecraft.lily_of_the_valley": "Ынйы сәскә",
  "block.minecraft.lily_pad": "Томбойоҡ",
  "block.minecraft.lime_banner": "Йәшкелт байраҡ",
  "block.minecraft.lime_bed": "Йәшкелт карауат",
  "block.minecraft.lime_candle": "Йәшкелт шәм",
  "block.minecraft.lime_candle_cake": "Йәшкелт шәм менән торт",
  "block.minecraft.lime_carpet": "Йәшкелт келәм",
  "block.minecraft.lime_concrete": "Йәшкелт бетон",
  "block.minecraft.lime_concrete_powder": "Йәшкелт ҡоро бетон",
  "block.minecraft.lime_glazed_terracotta": "Йәшкелт ялтырауыҡлы яндырығашы",
  "block.minecraft.lime_shulker_box": "Йәшкелт шалкер ҡумтаһы",
  "block.minecraft.lime_stained_glass": "Йәшкелт быяла",
  "block.minecraft.lime_stained_glass_pane": "Йәшкелт биҙәкле быяла",
  "block.minecraft.lime_terracotta": "Йәшкелт яндырығашы",
  "block.minecraft.lime_wool": "Йәшкелт йөн",
  "block.minecraft.lodestone": "Магнетит",
  "block.minecraft.loom": "Туҡыу эшкәрлеге",
  "block.minecraft.magenta_banner": "Ҡуйы ҡыҙыл байраҡ",
  "block.minecraft.magenta_bed": "Ҡуйы ҡыҙыл карауат",
  "block.minecraft.magenta_candle": "Ҡуйы ҡыҙыл шәм",
  "block.minecraft.magenta_candle_cake": "Ҡуйы ҡыҙыл шәм менән торт",
  "block.minecraft.magenta_carpet": "Ҡуйы ҡыҙыл келәм",
  "block.minecraft.magenta_concrete": "Ҡуйы ҡыҙыл бетон",
  "block.minecraft.magenta_concrete_powder": "Ҡуйы ҡыҙыл ҡоро бетон",
  "block.minecraft.magenta_glazed_terracotta": "Ҡуйы ҡыҙыл ялтырауыҡлы яндырығашы",
  "block.minecraft.magenta_shulker_box": "Ҡуйы ҡыҙыл шалкер ҡумтаһы",
  "block.minecraft.magenta_stained_glass": "Ҡуйы ҡыҙыл быяла",
  "block.minecraft.magenta_stained_glass_pane": "Ҡуйы ҡыҙыл биҙәкле быяла",
  "block.minecraft.magenta_terracotta": "Ҡуйы ҡыҙыл яндырығашы",
  "block.minecraft.magenta_wool": "Ҡуйы ҡыҙыл йөн",
  "block.minecraft.magma_block": "Магма",
  "block.minecraft.mangrove_button": "Мангр төймәһе",
  "block.minecraft.mangrove_door": "Мангр ишеге",
  "block.minecraft.mangrove_fence": "Мангр ҡоймаһы",
  "block.minecraft.mangrove_fence_gate": "Мангр ҡапҡаһы",
  "block.minecraft.mangrove_hanging_sign": "Мангр алтаҡта",
  "block.minecraft.mangrove_leaves": "Мангр япраҡтары",
  "block.minecraft.mangrove_log": "Мангр бүрәнәһе",
  "block.minecraft.mangrove_planks": "Мангр таҡталары",
  "block.minecraft.mangrove_pressure_plate": "Мангр ҡыҫым плитаһы",
  "block.minecraft.mangrove_propagule": "Мангр ботағы",
  "block.minecraft.mangrove_roots": "Мангр тамырҙары",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Мангр яҙмаҡсалығы",
  "block.minecraft.mangrove_slab": "Мангр плитаһы",
  "block.minecraft.mangrove_stairs": "Мангр баҫҡыстары",
  "block.minecraft.mangrove_trapdoor": "Мангр люгы",
  "block.minecraft.mangrove_wall_hanging_sign": "Мангр диуар алтаҡтаһы",
  "block.minecraft.mangrove_wall_sign": "Мангр диуар билдәһе",
  "block.minecraft.mangrove_wood": "Мангр ағасы",
  "block.minecraft.medium_amethyst_bud": "Уртасы аметист бөрөһө",
  "block.minecraft.melon": "Ҡарбуз",
  "block.minecraft.melon_stem": "Ҡарбуз һабағы",
  "block.minecraft.moss_block": "Мүк блогы",
  "block.minecraft.moss_carpet": "Мүк келәме",
  "block.minecraft.mossy_cobblestone": "Мүкләнгән һуйырташ",
  "block.minecraft.mossy_cobblestone_slab": "Мүкләнгән һуйырташ плитаһы",
  "block.minecraft.mossy_cobblestone_stairs": "Мүкләнгән һуйырташ баҫҡыстары",
  "block.minecraft.mossy_cobblestone_wall": "Мүкләнгән һуйырташ ҡоймаһы",
  "block.minecraft.mossy_stone_brick_slab": "Мүкләнгән таш кирбес плитаһы",
  "block.minecraft.mossy_stone_brick_stairs": "Мүкләнгән таш кирбестәр баҫҡыстары",
  "block.minecraft.mossy_stone_brick_wall": "Мүкләнгән таш кирбес ҡоймаһы",
  "block.minecraft.mossy_stone_bricks": "Мүкләнгән таш кирбестәре",
  "block.minecraft.moving_piston": "Бара торҡан бешкәк",
  "block.minecraft.mud": "Бысраҡ",
  "block.minecraft.mud_brick_slab": "Саман кирбес плитаһы",
  "block.minecraft.mud_brick_stairs": "Саман кирбес баҫҡыстары",
  "block.minecraft.mud_brick_wall": "Саман кирбес ҡоймаһы",
  "block.minecraft.mud_bricks": "Саман кирбестәре",
  "block.minecraft.muddy_mangrove_roots": "Бысраҡ мангр тамырҙары",
  "block.minecraft.mushroom_stem": "Бәшмәк һабағы",
  "block.minecraft.mycelium": "Бәшмәклек",
  "block.minecraft.nether_brick_fence": "Неҙер кирбес ҡоймаһы",
  "block.minecraft.nether_brick_slab": "Неҙер кирбес плитаһы",
  "block.minecraft.nether_brick_stairs": "Неҙер кирбес баҫҡыстары",
  "block.minecraft.nether_brick_wall": "Неҙер кирбес ҡоймаһы",
  "block.minecraft.nether_bricks": "Неҙер кирбестәре",
  "block.minecraft.nether_gold_ore": "Неҙер-алтын мәғдәне",
  "block.minecraft.nether_portal": "Неҙер порталы",
  "block.minecraft.nether_quartz_ore": "Неҙер-кварц мәғдәне",
  "block.minecraft.nether_sprouts": "Неҙер шытымы",
  "block.minecraft.nether_wart": "Неҙер ҡатламы",
  "block.minecraft.nether_wart_block": "Неҙер ҡатламының блогы",
  "block.minecraft.netherite_block": "Неҙерит блогы",
  "block.minecraft.netherrack": "Неҙеррәк",
  "block.minecraft.note_block": "Ноталар блогы",
  "block.minecraft.oak_button": "Имән төймәһе",
  "block.minecraft.oak_door": "Имән ишеге",
  "block.minecraft.oak_fence": "Имән ҡоймаһы",
  "block.minecraft.oak_fence_gate": "Имән ҡапҡаһы",
  "block.minecraft.oak_hanging_sign": "Имән алтаҡта",
  "block.minecraft.oak_leaves": "Имән япраҡтары",
  "block.minecraft.oak_log": "Имән бүрәнәһе",
  "block.minecraft.oak_planks": "Имән таҡталары",
  "block.minecraft.oak_pressure_plate": "Имән ҡыҫым плитаһы",
  "block.minecraft.oak_sapling": "Имән үҫентеһе",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Имән яҙмаҡсалығы",
  "block.minecraft.oak_slab": "Имән плитаһы",
  "block.minecraft.oak_stairs": "Имән баҫҡыстары",
  "block.minecraft.oak_trapdoor": "Имән люге",
  "block.minecraft.oak_wall_hanging_sign": "Диуар имән алтаҡтаһы",
  "block.minecraft.oak_wall_sign": "Имән диуар билдәһе",
  "block.minecraft.oak_wood": "Имән",
  "block.minecraft.observer": "Күҙәтеүсе",
  "block.minecraft.obsidian": "Обсидиан",
  "block.minecraft.ochre_froglight": "Охра төҫлө яҡтыбаҡа",
  "block.minecraft.ominous_banner": "Дәһшәтле байраҡ",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Хәнәүәт байраҡ",
  "block.minecraft.orange_bed": "Хәнәүәт карауат",
  "block.minecraft.orange_candle": "Хәнәүәт шәм",
  "block.minecraft.orange_candle_cake": "Хәнәүәт шәм менән торт",
  "block.minecraft.orange_carpet": "Хәнәүәт келәм",
  "block.minecraft.orange_concrete": "Хәнәүәт бетон",
  "block.minecraft.orange_concrete_powder": "Хәнәүәт ҡоро бетон",
  "block.minecraft.orange_glazed_terracotta": "Ҡыҙғылт һары ялтырауыҡлы яндырығашы",
  "block.minecraft.orange_shulker_box": "Ҡыҙғылт һары шалкер ҡумтаһы",
  "block.minecraft.orange_stained_glass": "Хәнәүәт быяла",
  "block.minecraft.orange_stained_glass_pane": "Хәнәүәт биҙәкле быяла",
  "block.minecraft.orange_terracotta": "Ҡыҙғылт һары яндырығашы",
  "block.minecraft.orange_tulip": "Хәнәүәт ләлә",
  "block.minecraft.orange_wool": "Хәнәүәт йөн",
  "block.minecraft.oxeye_daisy": "Аҡ сәскә",
  "block.minecraft.oxidized_chiseled_copper": "Окисланған семәрле баҡыр",
  "block.minecraft.oxidized_copper": "Окисланған баҡыр",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Окисланған баҡыр лампаһы",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Окисланған баҡыр ишек",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Окисланған баҡыр рәшәткә",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Окисланған баҡыр люк",
  "block.minecraft.oxidized_cut_copper": "Окисланған һырлы баҡыр",
  "block.minecraft.oxidized_cut_copper_slab": "Окисланған һырлы баҡыр плитаһы",
  "block.minecraft.oxidized_cut_copper_stairs": "Окисланған һырлы баҡыр баҫҡыстары",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Ҡалын боҙ",
  "block.minecraft.packed_mud": "Саман",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Тоноҡ мүк блогы",
  "block.minecraft.pale_moss_carpet": "Тоноҡ мүк келәме",
  "block.minecraft.pale_oak_button": "Тоноҡ имән төймә",
  "block.minecraft.pale_oak_door": "Тоноҡ имән ишек",
  "block.minecraft.pale_oak_fence": "Тоноҡ имән ҡойма",
  "block.minecraft.pale_oak_fence_gate": "Тоноҡ имән ҡапҡа",
  "block.minecraft.pale_oak_hanging_sign": "Тоноҡ имән алтаҡта",
  "block.minecraft.pale_oak_leaves": "Тоноҡ имән япраҡтары",
  "block.minecraft.pale_oak_log": "Тоноҡ имән бүрәнәһе",
  "block.minecraft.pale_oak_planks": "Тоноҡ имән таҡталар",
  "block.minecraft.pale_oak_pressure_plate": "Тоноҡ имән ҡыҫым плитаһы",
  "block.minecraft.pale_oak_sapling": "Тоноҡ имән үҫентеһе",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Тоноҡ имән яҙмаҡсалыҡ",
  "block.minecraft.pale_oak_slab": "Тоноҡ имән плита",
  "block.minecraft.pale_oak_stairs": "Тоноҡ имән баҫҡыстар",
  "block.minecraft.pale_oak_trapdoor": "Тоноҡ имән люк",
  "block.minecraft.pale_oak_wall_hanging_sign": "Тоноҡ имән диуар алтаҡтаһы",
  "block.minecraft.pale_oak_wall_sign": "Тоноҡ имән диуар билдәһе",
  "block.minecraft.pale_oak_wood": "Тоноҡ имән",
  "block.minecraft.pearlescent_froglight": "Мәрүәт төҫлө яҡтыбаҡа",
  "block.minecraft.peony": "Дөр-дөр",
  "block.minecraft.petrified_oak_slab": "Ташҡа әйләнгән имән плита",
  "block.minecraft.piglin_head": "Пиглин башы",
  "block.minecraft.piglin_wall_head": "Пиглин диуар башы",
  "block.minecraft.pink_banner": "Алһыу байраҡ",
  "block.minecraft.pink_bed": "Алһыу карауат",
  "block.minecraft.pink_candle": "Алһыу шәм",
  "block.minecraft.pink_candle_cake": "Алһыу шәм менән торт",
  "block.minecraft.pink_carpet": "Алһыу келәм",
  "block.minecraft.pink_concrete": "Алһыу бетон",
  "block.minecraft.pink_concrete_powder": "Алһыу ҡоро бетон",
  "block.minecraft.pink_glazed_terracotta": "Алһыу ялтырауыҡлы яндырығашы",
  "block.minecraft.pink_petals": "Алһыу таждар",
  "block.minecraft.pink_shulker_box": "Алһыу шалкер ҡумтаһы",
  "block.minecraft.pink_stained_glass": "Алһыу быяла",
  "block.minecraft.pink_stained_glass_pane": "Алһыу биҙәкле быяла",
  "block.minecraft.pink_terracotta": "Алһыу яндырығашы",
  "block.minecraft.pink_tulip": "Алһыу ләлә",
  "block.minecraft.pink_wool": "Алһыу йөн",
  "block.minecraft.piston": "Бешкәк",
  "block.minecraft.piston_head": "Бешкәк башы",
  "block.minecraft.pitcher_crop": "Ҡомғансы үҫентеһе",
  "block.minecraft.pitcher_plant": "Ҡомғансы",
  "block.minecraft.player_head": "Уйнаусының бышы",
  "block.minecraft.player_head.named": "%s башы",
  "block.minecraft.player_wall_head": "Диуарҙағы уйнаусының башы",
  "block.minecraft.podzol": "Көлһыу тупраҡ",
  "block.minecraft.pointed_dripstone": "Тамсылыҡ",
  "block.minecraft.polished_andesite": "Шымартылған андезит",
  "block.minecraft.polished_andesite_slab": "Шымартылған андезит плитаһы",
  "block.minecraft.polished_andesite_stairs": "Шымартылған андезит баҫҡыстары",
  "block.minecraft.polished_basalt": "Шымартылған базальт",
  "block.minecraft.polished_blackstone": "Шымартылған ҡараташ",
  "block.minecraft.polished_blackstone_brick_slab": "Шымартылған ҡараташ кирбес плитаһы",
  "block.minecraft.polished_blackstone_brick_stairs": "Шымартылған ҡараташ кирбес баҫҡыстары",
  "block.minecraft.polished_blackstone_brick_wall": "Шымартылған ҡараташ кирбес ҡоймаһы",
  "block.minecraft.polished_blackstone_bricks": "Шымартылған ҡараташ кирбестәре",
  "block.minecraft.polished_blackstone_button": "Шымартылған ҡараташ төймәһе",
  "block.minecraft.polished_blackstone_pressure_plate": "Шымартылған ҡараташ ҡыҫым плитаһы",
  "block.minecraft.polished_blackstone_slab": "Шымартылған ҡараташ плитаһы",
  "block.minecraft.polished_blackstone_stairs": "Шымартылған ҡараташ баҫҡыстары",
  "block.minecraft.polished_blackstone_wall": "Шымартылған ҡараташ ҡоймаһы",
  "block.minecraft.polished_deepslate": "Шымартылған һәүерташ",
  "block.minecraft.polished_deepslate_slab": "Шымартылған һәүерташ плитаһы",
  "block.minecraft.polished_deepslate_stairs": "Шымартылған һәүерташ баҫҡыстары",
  "block.minecraft.polished_deepslate_wall": "Шымартылған һәүерташ ҡоймаһы",
  "block.minecraft.polished_diorite": "Шымартылған диорит",
  "block.minecraft.polished_diorite_slab": "Шымартылған диорит плитаһы",
  "block.minecraft.polished_diorite_stairs": "Шымартылған диорит баҫҡыстары",
  "block.minecraft.polished_granite": "Шымартылған гранит",
  "block.minecraft.polished_granite_slab": "Шымартылған гранит баҫҡыстары",
  "block.minecraft.polished_granite_stairs": "Шымартылған гранит баҫҡыстары",
  "block.minecraft.polished_tuff": "Шымартылған туф",
  "block.minecraft.polished_tuff_slab": "Шымартылған туф плитаһы",
  "block.minecraft.polished_tuff_stairs": "Шымартылған туф баҫҡыстары",
  "block.minecraft.polished_tuff_wall": "Шымартылған туф ҡоймаһы",
  "block.minecraft.poppy": "Мәк",
  "block.minecraft.potatoes": "Бәрәңге",
  "block.minecraft.potted_acacia_sapling": "Ултыртылған сәрүәр үҫентеһе",
  "block.minecraft.potted_allium": "Ултыртылған йыллау һуған",
  "block.minecraft.potted_azalea_bush": "Игелгән азалия",
  "block.minecraft.potted_azure_bluet": "Ултыртылған зәңгәр күк сәскә",
  "block.minecraft.potted_bamboo": "Ултыртылған бамбук",
  "block.minecraft.potted_birch_sapling": "Ултыртылған ҡайын үҫентеһе",
  "block.minecraft.potted_blue_orchid": "Ултыртылған күк орхидея",
  "block.minecraft.potted_brown_mushroom": "Ултыртылған көрән бәшмәк",
  "block.minecraft.potted_cactus": "Ултыртылған кактус",
  "block.minecraft.potted_cherry_sapling": "Ултыртылған сейә ағас үҫентеһе",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Ултыртылған зәңгәр сәскә",
  "block.minecraft.potted_crimson_fungus": "Ултыртырған бурлат бәшмәге",
  "block.minecraft.potted_crimson_roots": "Ултыртылған бурлат тамырҙары",
  "block.minecraft.potted_dandelion": "Ултыртылған бәпембә",
  "block.minecraft.potted_dark_oak_sapling": "Ултыртылған ҡара имән үҫентеһе",
  "block.minecraft.potted_dead_bush": "Ултыртылған үле ҡыуаҡ",
  "block.minecraft.potted_fern": "Ултыртылған ҡаҙаяҡ",
  "block.minecraft.potted_flowering_azalea_bush": "Игелгән гөлләгән азалия",
  "block.minecraft.potted_golden_dandelion": "Ултыртылған алтын бәпембә",
  "block.minecraft.potted_jungle_sapling": "Ултыртылған тропик ағас үҫентеһе",
  "block.minecraft.potted_lily_of_the_valley": "Ултыртылған ынйы сәскә",
  "block.minecraft.potted_mangrove_propagule": "Игелгән мангр ботағы",
  "block.minecraft.potted_oak_sapling": "Ултыртылған имән үҫентеһе",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Ултыртылған ҡыҙғылт һары ләлә",
  "block.minecraft.potted_oxeye_daisy": "Ултыртылған бабунәж",
  "block.minecraft.potted_pale_oak_sapling": "Ултыртылған тоноҡ имән үҫентеһе",
  "block.minecraft.potted_pink_tulip": "Ултыртылған алһыу ләлә",
  "block.minecraft.potted_poppy": "Ултыртылған мәк",
  "block.minecraft.potted_red_mushroom": "Ултыртылған ҡыҙыл бәшмәк",
  "block.minecraft.potted_red_tulip": "Ултыртылған ҡыҙыл ләлә",
  "block.minecraft.potted_spruce_sapling": "Ултыртылған шыршы үҫентеһе",
  "block.minecraft.potted_torchflower": "Ултыртылған сыраҡгөл",
  "block.minecraft.potted_warped_fungus": "Ултыртылған боҙолған бәшмәге",
  "block.minecraft.potted_warped_roots": "Ултыртырған боҙолған тамырҙары",
  "block.minecraft.potted_white_tulip": "Ултыртылған аҡ ләлә",
  "block.minecraft.potted_wither_rose": "Ултыртылған виҙер сәскә",
  "block.minecraft.powder_snow": "Көпшәк ҡар",
  "block.minecraft.powder_snow_cauldron": "Көпшәк ҡар менән ҡаҙан",
  "block.minecraft.powered_rail": "Ҡеүәтле тимер юл",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Призмарин кирбес плитаһы",
  "block.minecraft.prismarine_brick_stairs": "Призмарин кирбес баҫҡыстары",
  "block.minecraft.prismarine_bricks": "Призмарин кирбестәре",
  "block.minecraft.prismarine_slab": "Призмарин плитаһы",
  "block.minecraft.prismarine_stairs": "Призмарин баҫҡыстары",
  "block.minecraft.prismarine_wall": "Призмарин ҡоймаһы",
  "block.minecraft.pumpkin": "Ҡабаҡ",
  "block.minecraft.pumpkin_stem": "Ҡабаҡ һабағы",
  "block.minecraft.purple_banner": "Шәмәхә байраҡ",
  "block.minecraft.purple_bed": "Шәмәхә карауат",
  "block.minecraft.purple_candle": "Шәмәхә шәм",
  "block.minecraft.purple_candle_cake": "Шәмәхә шәм менән торт",
  "block.minecraft.purple_carpet": "Шәмәхә келәм",
  "block.minecraft.purple_concrete": "Шәмәхә бетон",
  "block.minecraft.purple_concrete_powder": "Шәмәхә ҡоро бетон",
  "block.minecraft.purple_glazed_terracotta": "Шәмәхә ялтырауыҡлы яндырығашы",
  "block.minecraft.purple_shulker_box": "Шәмәхә шалкер ҡумтаһы",
  "block.minecraft.purple_stained_glass": "Шәмәхә быяла",
  "block.minecraft.purple_stained_glass_pane": "Шәмәхә биҙәкле быяла",
  "block.minecraft.purple_terracotta": "Шәмәхә яндырығашы",
  "block.minecraft.purple_wool": "Шәмәхә йөн",
  "block.minecraft.purpur_block": "Пурпур",
  "block.minecraft.purpur_pillar": "Пурпур бағана",
  "block.minecraft.purpur_slab": "Пурпур плитаһы",
  "block.minecraft.purpur_stairs": "Пурпур баҫҡыстары",
  "block.minecraft.quartz_block": "Кварц блогы",
  "block.minecraft.quartz_bricks": "Кварц кирбестәре",
  "block.minecraft.quartz_pillar": "Кварц бағанаһы",
  "block.minecraft.quartz_slab": "Кварц плитаһы",
  "block.minecraft.quartz_stairs": "Кварц баҫҡыстары",
  "block.minecraft.rail": "Тимер юл",
  "block.minecraft.raw_copper_block": "Эшкәртелмәгән баҡыр блогы",
  "block.minecraft.raw_gold_block": "Эшкәртелмәгән алтын блогы",
  "block.minecraft.raw_iron_block": "Эшкәртелмәгән тимер блогы",
  "block.minecraft.red_banner": "Ҡыҙыл байраҡ",
  "block.minecraft.red_bed": "Ҡыҙыл карауат",
  "block.minecraft.red_candle": "Ҡыҙыл шәм",
  "block.minecraft.red_candle_cake": "Ҡыҙыл шәм менән торт",
  "block.minecraft.red_carpet": "Ҡыҙыл келәм",
  "block.minecraft.red_concrete": "Ҡыҙыл бетон",
  "block.minecraft.red_concrete_powder": "Ҡыҙыл ҡоро бетон",
  "block.minecraft.red_glazed_terracotta": "Ҡыҙыл ялтырауыҡлы яндырығашы",
  "block.minecraft.red_mushroom": "Ҡыҙыл бәшмәк",
  "block.minecraft.red_mushroom_block": "Ҡыҙыл бәшмәк блогы",
  "block.minecraft.red_nether_brick_slab": "Ҡыҙыл неҙер кирбес плитаһы",
  "block.minecraft.red_nether_brick_stairs": "Ҡыҙыл неҙер кирбес баҫҡыстары",
  "block.minecraft.red_nether_brick_wall": "Ҡыҙыл неҙер кирбес ҡоймаһы",
  "block.minecraft.red_nether_bricks": "Ҡыҙыл неҙер кирбесе",
  "block.minecraft.red_sand": "Ҡыҙыл ҡом",
  "block.minecraft.red_sandstone": "Ҡыҙыл ҡомташ",
  "block.minecraft.red_sandstone_slab": "Ҡыҙыл ҡомташ плитаһы",
  "block.minecraft.red_sandstone_stairs": "Ҡыҙыл ҡомташ баҫҡыстары",
  "block.minecraft.red_sandstone_wall": "Ҡыҙыл ҡомташ ҡоймаһы",
  "block.minecraft.red_shulker_box": "Ҡыҙыл шалкер ҡумтаһы",
  "block.minecraft.red_stained_glass": "Ҡыҙыл быяла",
  "block.minecraft.red_stained_glass_pane": "Ҡыҙыл биҙәкле быяла",
  "block.minecraft.red_terracotta": "Ҡыҙыл яндырығашы",
  "block.minecraft.red_tulip": "Ҡыҙыл ләлә",
  "block.minecraft.red_wool": "Ҡыҙыл йөн",
  "block.minecraft.redstone_block": "Редстоун блогы",
  "block.minecraft.redstone_lamp": "Редстоун шәме",
  "block.minecraft.redstone_ore": "Редстоун мәғдәне",
  "block.minecraft.redstone_torch": "Редстоун сырағы",
  "block.minecraft.redstone_wall_torch": "Редстоун диуар сырағы",
  "block.minecraft.redstone_wire": "Редстоун үткәргесе",
  "block.minecraft.reinforced_deepslate": "Нығыртылған һәүерташ",
  "block.minecraft.repeater": "Редстоун ҡабатлаусы",
  "block.minecraft.repeating_command_block": "Ҡабатланған бойороҡ блогы",
  "block.minecraft.resin_block": "Ыҫмала блогы",
  "block.minecraft.resin_brick_slab": "Ыҫмала кирбес плитаһы",
  "block.minecraft.resin_brick_stairs": "Ыҫмала кирбес баҫҡыстары",
  "block.minecraft.resin_brick_wall": "Ыҫмала кирбес ҡоймаһы",
  "block.minecraft.resin_bricks": "Ыҫмала кирбестәре",
  "block.minecraft.resin_clump": "Ыҫмала ҡуйырығы",
  "block.minecraft.respawn_anchor": "Терелтеү якоры",
  "block.minecraft.rooted_dirt": "Тамырланған тупраҡ",
  "block.minecraft.rose_bush": "Роза ҡыуағы",
  "block.minecraft.sand": "Ҡом",
  "block.minecraft.sandstone": "Ҡомташ",
  "block.minecraft.sandstone_slab": "Ҡомташ плитаһы",
  "block.minecraft.sandstone_stairs": "Ҡомташ баҫҡыстары",
  "block.minecraft.sandstone_wall": "Ҡомташ ҡоймаһы",
  "block.minecraft.scaffolding": "Баҫма",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалк катализаторы",
  "block.minecraft.sculk_sensor": "Скалк сенсор",
  "block.minecraft.sculk_shrieker": "Скалк сәрелдәге",
  "block.minecraft.sculk_vein": "Скалк тамыры",
  "block.minecraft.sea_lantern": "Диңгеҙ күге",
  "block.minecraft.sea_pickle": "Диңгеҙ ҡыяры",
  "block.minecraft.seagrass": "Диңгеҙ уләне",
  "block.minecraft.set_spawn": "Терелтеү нөктәһе урынлаштырылды",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Бәләкәй үлән",
  "block.minecraft.shroomlight": "Нурбәшмәк",
  "block.minecraft.shulker_box": "Шалкер ҡумтаһы",
  "block.minecraft.skeleton_skull": "Һөлдә башы",
  "block.minecraft.skeleton_wall_skull": "Диуарҙағы һөлдә башы",
  "block.minecraft.slime_block": "Лайлас блогы",
  "block.minecraft.small_amethyst_bud": "Бәләкәс аметист бөрөһө",
  "block.minecraft.small_dripleaf": "Кесе тамсыяпраҡ",
  "block.minecraft.smithing_table": "Тимерсенең өҫтәле",
  "block.minecraft.smoker": "Ыҫҡарғы",
  "block.minecraft.smooth_basalt": "Шыма базальт",
  "block.minecraft.smooth_quartz": "Шыма кварц блогы",
  "block.minecraft.smooth_quartz_slab": "Шыма кварц плитаһы",
  "block.minecraft.smooth_quartz_stairs": "Шыма кварц баҫҡыстары",
  "block.minecraft.smooth_red_sandstone": "Шыма ҡыҙыл ҡомташ",
  "block.minecraft.smooth_red_sandstone_slab": "Шыма ҡыҙыл ҡомташ баҫҡыстары",
  "block.minecraft.smooth_red_sandstone_stairs": "Шыма ҡыҙыл ҡомташ баҫҡыстары",
  "block.minecraft.smooth_sandstone": "Шыма ҡомташ",
  "block.minecraft.smooth_sandstone_slab": "Шыма ҡомташ плитаһы",
  "block.minecraft.smooth_sandstone_stairs": "Шыма ҡомташ баҫҡыстары",
  "block.minecraft.smooth_stone": "Шыма таш",
  "block.minecraft.smooth_stone_slab": "Шыма таш плитаһы",
  "block.minecraft.sniffer_egg": "Еҫкәүсе йомортҡаһы",
  "block.minecraft.snow": "Ҡар",
  "block.minecraft.snow_block": "Ҡар блогы",
  "block.minecraft.soul_campfire": "Йән усағы",
  "block.minecraft.soul_fire": "Йәнле ут",
  "block.minecraft.soul_lantern": "Йән күге",
  "block.minecraft.soul_sand": "Йәнле ҡом",
  "block.minecraft.soul_soil": "Йәнле тупраҡ",
  "block.minecraft.soul_torch": "Йәнле сырағы",
  "block.minecraft.soul_wall_torch": "Йәнле диуар сырағы",
  "block.minecraft.spawn.not_valid": "Һеҙҙә кырауат әммә ҡоролған тергеҙеү якоры юҡ, йәки улар тыйылған урында",
  "block.minecraft.spawner": "Ҡурҡыныслыҡ яралтҡысы",
  "block.minecraft.spawner.desc1": "Сыҡарыу йомортҡаһы менән йоҡташыу:",
  "block.minecraft.spawner.desc2": "Моб төрөн билдәләй",
  "block.minecraft.sponge": "Болот",
  "block.minecraft.spore_blossom": "Спора сәскәлеге",
  "block.minecraft.spruce_button": "Шыршы төймәһе",
  "block.minecraft.spruce_door": "Шыршы ишеге",
  "block.minecraft.spruce_fence": "Шыршы ҡоймаһы",
  "block.minecraft.spruce_fence_gate": "Шыршы ҡапҡаһы",
  "block.minecraft.spruce_hanging_sign": "Шыршы алтаҡта",
  "block.minecraft.spruce_leaves": "Шыршы япраҡтары",
  "block.minecraft.spruce_log": "Шыршы бүрәнәһе",
  "block.minecraft.spruce_planks": "Шыршы таҡталары",
  "block.minecraft.spruce_pressure_plate": "Шыршы ҡыҫым плитаһы",
  "block.minecraft.spruce_sapling": "Шыршы үҫентеһе",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Шыршы яҙмаҡсалығы",
  "block.minecraft.spruce_slab": "Шыршы плитаһы",
  "block.minecraft.spruce_stairs": "Шыршы баҫҡыстары",
  "block.minecraft.spruce_trapdoor": "Шыршы люгы",
  "block.minecraft.spruce_wall_hanging_sign": "Шыршы диуар алтаҡтаһы",
  "block.minecraft.spruce_wall_sign": "Шыршы диуар билдәһе",
  "block.minecraft.spruce_wood": "Шыршы",
  "block.minecraft.sticky_piston": "Йәбешкәк бешкәк",
  "block.minecraft.stone": "Таш",
  "block.minecraft.stone_brick_slab": "Таш кирбес плитаһы",
  "block.minecraft.stone_brick_stairs": "Таш кирбес баҫҡыстары",
  "block.minecraft.stone_brick_wall": "Таш кирбес ҡоймаһы",
  "block.minecraft.stone_bricks": "Таш кирбестәре",
  "block.minecraft.stone_button": "Таш төймә",
  "block.minecraft.stone_pressure_plate": "Таш ҡыҫым плитаһы",
  "block.minecraft.stone_slab": "Таш плитаһы",
  "block.minecraft.stone_stairs": "Таш баҫҡыстары",
  "block.minecraft.stonecutter": "Ташкиҫкес",
  "block.minecraft.stripped_acacia_log": "Юнылған сәрүәр бүрәнәһе",
  "block.minecraft.stripped_acacia_wood": "Юнылған сәрүәр",
  "block.minecraft.stripped_bamboo_block": "Юнылған бамбук блогы",
  "block.minecraft.stripped_birch_log": "Юнылған ҡайын бүрәнәһе",
  "block.minecraft.stripped_birch_wood": "Юнылған ҡайын",
  "block.minecraft.stripped_cherry_log": "Юнылған сейә ағас бүрәнәһе",
  "block.minecraft.stripped_cherry_wood": "Юнылған сейә ағас",
  "block.minecraft.stripped_crimson_hyphae": "Юнылған бурлат һифалары",
  "block.minecraft.stripped_crimson_stem": "Юнылған бурлат һабағы",
  "block.minecraft.stripped_dark_oak_log": "Юнылған ҡара имән бүрәнәһе",
  "block.minecraft.stripped_dark_oak_wood": "Юнылған ҡара имән",
  "block.minecraft.stripped_jungle_log": "Юнылған тропик ағас бүрәнәһе",
  "block.minecraft.stripped_jungle_wood": "Юнылған тропик ағасы",
  "block.minecraft.stripped_mangrove_log": "Юнылған мангр бүрәнәһе",
  "block.minecraft.stripped_mangrove_wood": "Юнылған мангр ағасы",
  "block.minecraft.stripped_oak_log": "Юнылған имән бүрәнәһе",
  "block.minecraft.stripped_oak_wood": "Юнылған имән",
  "block.minecraft.stripped_pale_oak_log": "Юнылған тоноҡ имән бүрәнәһе",
  "block.minecraft.stripped_pale_oak_wood": "Юнылған тоноҡ имән",
  "block.minecraft.stripped_spruce_log": "Юнылған шыршы бүрәнәһе",
  "block.minecraft.stripped_spruce_wood": "Юнылған шыршы",
  "block.minecraft.stripped_warped_hyphae": "Юнылған боҙолған һифалары",
  "block.minecraft.stripped_warped_stem": "Юнылған боҙолған һабағы",
  "block.minecraft.structure_block": "Структуралыҡ блогы",
  "block.minecraft.structure_void": "Буш блогы",
  "block.minecraft.sugar_cane": "Ҡәнд ҡамышы",
  "block.minecraft.sunflower": "Көнбағыш",
  "block.minecraft.suspicious_gravel": "Серле ҡырсынташ",
  "block.minecraft.suspicious_sand": "Серле ҡом",
  "block.minecraft.sweet_berry_bush": "Тәмле-татлы емеш ҡыуағы",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Бейек үлән",
  "block.minecraft.tall_seagrass": "Бейек диңгез үләне",
  "block.minecraft.target": "Сәп",
  "block.minecraft.terracotta": "Терракота",
  "block.minecraft.test_block": "Тест блогы",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Ҡараңғыланған быяла",
  "block.minecraft.tnt": "Динамит",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Сыраҡ",
  "block.minecraft.torchflower": "Сыраҡгөл",
  "block.minecraft.torchflower_crop": "Сыраҡгөл шытымы",
  "block.minecraft.trapped_chest": "Ҡапҡан-һандыҡ",
  "block.minecraft.trial_spawner": "Һынау яралтҡысы",
  "block.minecraft.tripwire": "Киремтә",
  "block.minecraft.tripwire_hook": "Ырғаҡ",
  "block.minecraft.tube_coral": "Көпшәле мәрйен",
  "block.minecraft.tube_coral_block": "Көпшәле мәрйен блогы",
  "block.minecraft.tube_coral_fan": "Елпеүесле көпшәлек мәрйен",
  "block.minecraft.tube_coral_wall_fan": "Ятма елпеүесле көпшәлек мәрйен",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Туф кирбес плитаһы",
  "block.minecraft.tuff_brick_stairs": "Туф кирбес баҫҡыстары",
  "block.minecraft.tuff_brick_wall": "Туф кирбес ҡоймаһы",
  "block.minecraft.tuff_bricks": "Туф кирбестәре",
  "block.minecraft.tuff_slab": "Туф плитаһы",
  "block.minecraft.tuff_stairs": "Туф баҫҡыстары",
  "block.minecraft.tuff_wall": "Туф ҡоймаһы",
  "block.minecraft.turtle_egg": "Гөбөргәйел йомортҡаһы",
  "block.minecraft.twisting_vines": "Сырмалыусан тал",
  "block.minecraft.twisting_vines_plant": "Сырмалыусан тал һабағы",
  "block.minecraft.vault": "Һаҡланғыс",
  "block.minecraft.verdant_froglight": "Үлән төҫлө яҡтыбаҡа",
  "block.minecraft.vine": "Лианалар",
  "block.minecraft.void_air": "Вакуум",
  "block.minecraft.wall_torch": "Диуар сырағы",
  "block.minecraft.warped_button": "Боҙолған төймә",
  "block.minecraft.warped_door": "Боҙолған ишек",
  "block.minecraft.warped_fence": "Боҙолған ҡоймалар",
  "block.minecraft.warped_fence_gate": "Боҙолған ҡапҡаһы",
  "block.minecraft.warped_fungus": "Боҙолған бәшмәк",
  "block.minecraft.warped_hanging_sign": "Боҙолған алтаҡта",
  "block.minecraft.warped_hyphae": "Боҙолған һифалары",
  "block.minecraft.warped_nylium": "Боҙолған нәҙмәклек",
  "block.minecraft.warped_planks": "Боҙолған таҡталары",
  "block.minecraft.warped_pressure_plate": "Боҙолған ҡыҫым плитаһы",
  "block.minecraft.warped_roots": "Боҙолған тамырҙар",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Боҙолған яҙмаҡсалығы",
  "block.minecraft.warped_slab": "Боҙолған плитаһы",
  "block.minecraft.warped_stairs": "Боҙолған баҫҡыстар",
  "block.minecraft.warped_stem": "Боҙолған һабаҡ",
  "block.minecraft.warped_trapdoor": "Боҙолған люгы",
  "block.minecraft.warped_wall_hanging_sign": "Боҙолған диуар алтаҡтаһы",
  "block.minecraft.warped_wall_sign": "Боҙолған диуар алтаҡтаһы",
  "block.minecraft.warped_wart_block": "Боҙолған ҡатлам блогы",
  "block.minecraft.water": "Һыу",
  "block.minecraft.water_cauldron": "Һыу менән ҡаҙан",
  "block.minecraft.waxed_chiseled_copper": "Балауыҙлы семәрле баҡыр",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Балауыҙланған баҡыр блогы",
  "block.minecraft.waxed_copper_bulb": "Балауыҙлыбаҡыр шәме",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Балауыҙлы баҡыр ишек",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Балауыҙлы баҡыр рәшәткә",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Балауыҙлы баҡыр люк",
  "block.minecraft.waxed_cut_copper": "Балауыҙланған һырлы баҡыр",
  "block.minecraft.waxed_cut_copper_slab": "Балауыҙланған һырлы баҡыр плитаһы",
  "block.minecraft.waxed_cut_copper_stairs": "Балауыҙланған һырлы баҡыр баҫҡыстары",
  "block.minecraft.waxed_exposed_chiseled_copper": "Балауыҙлы ҡараланған семәрле баҡыр",
  "block.minecraft.waxed_exposed_copper": "Ҡарайған балауыҙланған баҡыр",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Балауыҙлы ҡараланған баҡыр шәме",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Балауыҙлы ҡараланған баҡыр ишек",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Балауыҙлы ҡараланҡан баҡыр рәшәткә",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Балауыҙлы ҡараланған баҡыр люк",
  "block.minecraft.waxed_exposed_cut_copper": "Ҡарайған балауыҙланған һырлы баҡыр",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ҡарайған балауыҙланған һырлы баҡыр плитаһы",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ҡарайған балауыҙланған һырлы баҡыр баҫҡыстары",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Балауыҙлы окисланған семәрле баҡыр",
  "block.minecraft.waxed_oxidized_copper": "Окисланған балауыҙланған баҡыр",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Балауыҙлы окисланған баҡыр шәме",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Балауыҙлы окисланған баҡыр ишек",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Балауыҙлы окисланған баҡыр рәшәткә",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Балауыҙлы окисланған баҡыр люк",
  "block.minecraft.waxed_oxidized_cut_copper": "Окисланған балауыҙланған һырлы баҡыр",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Окисланған балауыҙланған һырлы баҡыр плитаһы",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Окисланған балауыҙланған һырлы баҡыр баҫҡыстары",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Балауыҙлы иҫкергән семәрле баҡыр",
  "block.minecraft.waxed_weathered_copper": "Балауыҙлы күгәргән баҡыр",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Балауыҙлы иҫкергән баҡыр шәме",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Балауыҙлы иҫкергән баҡыр ишек",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Балауыҙлы иҫкергән баҡыр рәшәткә",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Балауыҙлы иҫкергән баҡыр люк",
  "block.minecraft.waxed_weathered_cut_copper": "Окисланып бөтмәгән балауыҙланған һырлы баҡыр",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Окисланып бөтмәгән балауыҙланған һырлы баҡыр плитаһы",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Окисланып бөтмәгән балауыҙланған һырлы баҡыр баҫҡыстары",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Иҫкергән семәрле баҡыр",
  "block.minecraft.weathered_copper": "Күгәргән баҡыр",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Иҫкергән баҡыр шәме",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Иҫкергән баҡыр ишек",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Иҫкергән баҡыр рәшәткә",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Иҫкергән баҡыр люк",
  "block.minecraft.weathered_cut_copper": "Күгәргән һырлы баҡыр",
  "block.minecraft.weathered_cut_copper_slab": "Күгәргән һырлы баҡыр плитаһы",
  "block.minecraft.weathered_cut_copper_stairs": "Күгәргән һырлы баҡыр баҫҡыстары",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Илаҡсы тал",
  "block.minecraft.weeping_vines_plant": "Илаҡсының тал һабағы",
  "block.minecraft.wet_sponge": "Еүеш болот",
  "block.minecraft.wheat": "Бойҙай шытымҙары",
  "block.minecraft.white_banner": "Аҡ байраҡ",
  "block.minecraft.white_bed": "Аҡ карауат",
  "block.minecraft.white_candle": "Аҡ шәм",
  "block.minecraft.white_candle_cake": "Аҡ шәм менән торт",
  "block.minecraft.white_carpet": "Аҡ келәм",
  "block.minecraft.white_concrete": "Аҡ бетон",
  "block.minecraft.white_concrete_powder": "Аҡ ҡоро бетон",
  "block.minecraft.white_glazed_terracotta": "Аҡ ялтырауыҡлы яндырығашы",
  "block.minecraft.white_shulker_box": "Аҡ шалкер ҡумтаһы",
  "block.minecraft.white_stained_glass": "Аҡ быяла",
  "block.minecraft.white_stained_glass_pane": "Аҡ биҙәкле быяла",
  "block.minecraft.white_terracotta": "Аҡ яндырығашы",
  "block.minecraft.white_tulip": "Аҡ ләлә",
  "block.minecraft.white_wool": "Аҡ йөн",
  "block.minecraft.wildflowers": "Ҡыр сәскәләре",
  "block.minecraft.wither_rose": "Виҙер сәскә",
  "block.minecraft.wither_skeleton_skull": "Виҙер-һөлдә башы",
  "block.minecraft.wither_skeleton_wall_skull": "Диуарҙағы визер-һөлдә башы",
  "block.minecraft.yellow_banner": "Һары байраҡ",
  "block.minecraft.yellow_bed": "Һары карауат",
  "block.minecraft.yellow_candle": "Һары шәм",
  "block.minecraft.yellow_candle_cake": "Һары шәм менән торт",
  "block.minecraft.yellow_carpet": "Һары келәм",
  "block.minecraft.yellow_concrete": "Һары бетон",
  "block.minecraft.yellow_concrete_powder": "Һары ҡоро бетон",
  "block.minecraft.yellow_glazed_terracotta": "Һары ялтырауыҡлы яндырығашы",
  "block.minecraft.yellow_shulker_box": "Һары шалкер ҡумтаһы",
  "block.minecraft.yellow_stained_glass": "Һары быяла",
  "block.minecraft.yellow_stained_glass_pane": "Һары биҙәкле быяла",
  "block.minecraft.yellow_terracotta": "Һары яндырығашы",
  "block.minecraft.yellow_wool": "Һары йөн",
  "block.minecraft.zombie_head": "Зомби башы",
  "block.minecraft.zombie_wall_head": "Диуарҙағы зомби башы",
  "item.minecraft.acacia_boat": "Сәрүәр кәмәһе",
  "item.minecraft.acacia_chest_boat": "Һандыҡлы сәрүәр кәмәһе",
  "item.minecraft.allay_spawn_egg": "Йыуатар саҡырыу йомортҡаһы",
  "item.minecraft.amethyst_shard": "Аметист ярсығы",
  "item.minecraft.angler_pottery_shard": "«Балыҡсы» сүлмәк ярсығы",
  "item.minecraft.angler_pottery_sherd": "«Балыҡсы» сүлмәк ярсығы",
  "item.minecraft.apple": "Алма",
  "item.minecraft.archer_pottery_shard": "«Уҡсы» сүлмәк ярсығы",
  "item.minecraft.archer_pottery_sherd": "«Уҡсы» сүлмәк ярсығы",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Жәбә терәге",
  "item.minecraft.arms_up_pottery_shard": "«Ҡулдарҙы өҫкә» сүлмәк ярсығы",
  "item.minecraft.arms_up_pottery_sherd": "«Ҡулдарҙы өҫкә» сүлмәк ярсығы",
  "item.minecraft.arrow": "Уҡ",
  "item.minecraft.axolotl_bucket": "Силәктәге аксолотль",
  "item.minecraft.axolotl_spawn_egg": "Аксолотль саҡырыу йомортҡаһы",
  "item.minecraft.baked_potato": "Бешерелгән бәрәңге",
  "item.minecraft.bamboo_chest_raft": "Һандыҡлы бамбук һал",
  "item.minecraft.bamboo_raft": "Бамбук һал",
  "item.minecraft.bat_spawn_egg": "Ярғанат саҡырыу йомортҡаһы",
  "item.minecraft.bee_spawn_egg": "Бал ҡорто саҡырыу йомортҡаһы",
  "item.minecraft.beef": "Сей һыйыр ите",
  "item.minecraft.beetroot": "Сөгөлдөр",
  "item.minecraft.beetroot_seeds": "Сөгөлдөр орлоҡтары",
  "item.minecraft.beetroot_soup": "Сөгөлдөр һурпаһы",
  "item.minecraft.birch_boat": "Ҡайын кәмәһе",
  "item.minecraft.birch_chest_boat": "Һандыҡлы ҡайын кәмәһе",
  "item.minecraft.black_bundle": "Ҡара тоҡ",
  "item.minecraft.black_dye": "Ҡара буяу",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "«Ҡылыс» сүлмәк ярсығы",
  "item.minecraft.blade_pottery_sherd": "«Ҡылыс» сүлмәк ярсығы",
  "item.minecraft.blaze_powder": "Ғифриттың онтағы",
  "item.minecraft.blaze_rod": "Ғифрит үҙәге",
  "item.minecraft.blaze_spawn_egg": "Ғифрит саҡырыу йомортҡаһы",
  "item.minecraft.blue_bundle": "Күк тоҡ",
  "item.minecraft.blue_dye": "Күк буяу",
  "item.minecraft.blue_egg": "Күк йомортҡа",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Һөйәк",
  "item.minecraft.bone_meal": "Һөйәк оно",
  "item.minecraft.book": "Китап",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Йәйә",
  "item.minecraft.bowl": "Сеүәтә",
  "item.minecraft.bread": "Икмәк",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "«Ҡайнатыусы» сүлмәк ярсығы",
  "item.minecraft.brewer_pottery_sherd": "«Ҡайнатыусы» сүлмәк ярсығы",
  "item.minecraft.brewing_stand": "Төнәтмә ҡайнатыу терәге",
  "item.minecraft.brick": "Кирбес",
  "item.minecraft.brown_bundle": "Көрән тоҡ",
  "item.minecraft.brown_dye": "Көрән буяу",
  "item.minecraft.brown_egg": "Көрән йомортҡа",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Бумала",
  "item.minecraft.bucket": "Силәк",
  "item.minecraft.bundle": "Тоҡ",
  "item.minecraft.bundle.empty": "Буш",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Тулы",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "«Ут» сүлмәк ярсығы",
  "item.minecraft.burn_pottery_sherd": "«Ут» сүлмәк ярсығы",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Дөйә саҡырыу йомортҡаһы",
  "item.minecraft.carrot": "Кишер",
  "item.minecraft.carrot_on_a_stick": "Кишерле ҡармаҡ",
  "item.minecraft.cat_spawn_egg": "Бесәй саҡырыу йомортҡаһы",
  "item.minecraft.cauldron": "Ҡаҙан",
  "item.minecraft.cave_spider_spawn_egg": "Мәмерйә үрмәксе саҡырыу йомортҡаһы",
  "item.minecraft.chainmail_boots": "Һайман итек",
  "item.minecraft.chainmail_chestplate": "Һайман",
  "item.minecraft.chainmail_helmet": "Койф",
  "item.minecraft.chainmail_leggings": "Һайман салбар",
  "item.minecraft.charcoal": "Ағас күмере",
  "item.minecraft.cherry_boat": "Сейә ағас кәмәһе",
  "item.minecraft.cherry_chest_boat": "Һандыҡлы сейә ағас кәмәһе",
  "item.minecraft.chest_minecart": "Һандыҡ менән вагонетка",
  "item.minecraft.chicken": "Сей тауыҡ ите",
  "item.minecraft.chicken_spawn_egg": "Тауыҡ саҡырыу йомортҡаһы",
  "item.minecraft.chorus_fruit": "Хорус емеше",
  "item.minecraft.clay_ball": "Балсыҡ төйөрө",
  "item.minecraft.clock": "Сәғәт",
  "item.minecraft.coal": "Күмер",
  "item.minecraft.coast_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Какао-борсаҡтары",
  "item.minecraft.cod": "Сей тәрәс",
  "item.minecraft.cod_bucket": "Силәктәге тәрәс",
  "item.minecraft.cod_spawn_egg": "Тәрәс саҡырыу йомортҡаһы",
  "item.minecraft.command_block_minecart": "Бойороҡ блоклы вагонетка",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Стейк",
  "item.minecraft.cooked_chicken": "Ҡурылған тауыҡ ите",
  "item.minecraft.cooked_cod": "Ҡурылған тәрәс",
  "item.minecraft.cooked_mutton": "Ҡурылған һарыҡ ите",
  "item.minecraft.cooked_porkchop": "Ҡурылған сусҡа ите",
  "item.minecraft.cooked_rabbit": "Ҡурылған ҡуян ите",
  "item.minecraft.cooked_salmon": "Ҡурылған һөмбаш",
  "item.minecraft.cookie": "Печенье",
  "item.minecraft.copper_axe": "Баҡыр балта",
  "item.minecraft.copper_boots": "Баҡыр итек",
  "item.minecraft.copper_chestplate": "Баҡыр күкрәксә",
  "item.minecraft.copper_golem_spawn_egg": "Баҡыр голем саҡырыу йомортҡаһы",
  "item.minecraft.copper_helmet": "Баҡыр торҡа",
  "item.minecraft.copper_hoe": "Баҡыр кетмән",
  "item.minecraft.copper_horse_armor": "Баҡыр ат жәбәһе",
  "item.minecraft.copper_ingot": "Баҡыр ҡойолмаһы",
  "item.minecraft.copper_leggings": "Баҡыр салбар",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Баҡыр киҫәге",
  "item.minecraft.copper_pickaxe": "Баҡыр кәйлә",
  "item.minecraft.copper_shovel": "Баҡыр көрәк",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Баҡыр ҡылыс",
  "item.minecraft.cow_spawn_egg": "Һыйыр саҡырыу йомортҡаһы",
  "item.minecraft.creaking_spawn_egg": "Шағыр-шоғор саҡырыу йомортҡаһы",
  "item.minecraft.creeper_banner_pattern": "Байраҡ биҙәге",
  "item.minecraft.creeper_banner_pattern.desc": "Крипер",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Крипер саҡырыу йомортҡаһы",
  "item.minecraft.crossbow": "Арбалет",
  "item.minecraft.crossbow.projectile": "Тулым:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Фирүзә тоҡ",
  "item.minecraft.cyan_dye": "Фирүзә буяу",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "«Хәүефлелек» сүлмәк ярсығы",
  "item.minecraft.danger_pottery_sherd": "«Хәүефлелек» сүлмәк ярсығы",
  "item.minecraft.dark_oak_boat": "Ҡара имән кәмәһе",
  "item.minecraft.dark_oak_chest_boat": "Һандыҡлы имән ағасынан кәмә",
  "item.minecraft.debug_stick": "Төҙәтеү таяҡсаһы",
  "item.minecraft.debug_stick.empty": "%s үҙенсәлектәре юҡ",
  "item.minecraft.debug_stick.select": "«%s» (%s) һайланған",
  "item.minecraft.debug_stick.update": "«%s»: %s",
  "item.minecraft.diamond": "Алмас",
  "item.minecraft.diamond_axe": "Алмас балта",
  "item.minecraft.diamond_boots": "Алмаслы итек",
  "item.minecraft.diamond_chestplate": "Алмас күкрәксә",
  "item.minecraft.diamond_helmet": "Алмас торҡа",
  "item.minecraft.diamond_hoe": "Алмас кетмән",
  "item.minecraft.diamond_horse_armor": "Алмас ат жәбәһе",
  "item.minecraft.diamond_leggings": "Алмаслы салбар",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Алмас кәйлә",
  "item.minecraft.diamond_shovel": "Алмас көрәк",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Алмас ҡылыс",
  "item.minecraft.disc_fragment_5": "Пластинка фрагменты",
  "item.minecraft.disc_fragment_5.desc": "Пластинка — 5",
  "item.minecraft.dolphin_spawn_egg": "Дельфин саҡырыу йомортҡаһы",
  "item.minecraft.donkey_spawn_egg": "Ишәк саҡырыу йомортҡаһы",
  "item.minecraft.dragon_breath": "Аждаһа тыны",
  "item.minecraft.dried_kelp": "Киптерелгән диңгеҙ кәбеҫтәһе",
  "item.minecraft.drowned_spawn_egg": "Батҡын саҡырыу йомортҡаһы",
  "item.minecraft.dune_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.dune_armor_trim_smithing_template.new": "«Дюна» биҙәге",
  "item.minecraft.echo_shard": "Шаңдау ярсығы",
  "item.minecraft.egg": "Йомортҡа",
  "item.minecraft.elder_guardian_spawn_egg": "Боронғо һаҡлаусы саҡырыу йомортҡаһы",
  "item.minecraft.elytra": "Элитралар",
  "item.minecraft.emerald": "Зөбәржәт",
  "item.minecraft.enchanted_book": "Сихырлы китап",
  "item.minecraft.enchanted_golden_apple": "Сихырлы алтын алма",
  "item.minecraft.end_crystal": "Энд кристаллы",
  "item.minecraft.ender_dragon_spawn_egg": "Эндер аждаһа саҡырыу йомортҡаһы",
  "item.minecraft.ender_eye": "Эндер күҙе",
  "item.minecraft.ender_pearl": "Эндер-ынйы",
  "item.minecraft.enderman_spawn_egg": "Эндермән саҡырыу йомортҡаһы",
  "item.minecraft.endermite_spawn_egg": "Эндермит саҡырыу йомортҡаһы",
  "item.minecraft.evoker_spawn_egg": "Арбаусы саҡырыу йомортҡаһы",
  "item.minecraft.experience_bottle": "Сихырлы шешә",
  "item.minecraft.explorer_pottery_shard": "«Тикшеренеүсе» сүлмәк ярсығы",
  "item.minecraft.explorer_pottery_sherd": "«Тикшеренеүсе» сүлмәк ярсығы",
  "item.minecraft.eye_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.eye_armor_trim_smithing_template.new": "«Күҙ» биҙәге",
  "item.minecraft.feather": "Ҡауырһын",
  "item.minecraft.fermented_spider_eye": "Маринадланған үрмәксенең күҙе",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Ерһүрәт",
  "item.minecraft.fire_charge": "Ут заряды",
  "item.minecraft.firework_rocket": "Фейерверк",
  "item.minecraft.firework_rocket.flight": "Осоу дауамлығы:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Фейерверк йондоҙо",
  "item.minecraft.firework_star.black": "Ҡара",
  "item.minecraft.firework_star.blue": "Күк",
  "item.minecraft.firework_star.brown": "Кәрән",
  "item.minecraft.firework_star.custom_color": "Ҡулланыусылы",
  "item.minecraft.firework_star.cyan": "Фирүзә",
  "item.minecraft.firework_star.fade_to": "Даими һүнеүе",
  "item.minecraft.firework_star.flicker": "Йымылдау",
  "item.minecraft.firework_star.gray": "Һоро",
  "item.minecraft.firework_star.green": "Йәшел",
  "item.minecraft.firework_star.light_blue": "Зәңгәр",
  "item.minecraft.firework_star.light_gray": "Аҡһыл һоро",
  "item.minecraft.firework_star.lime": "Йәшкелт",
  "item.minecraft.firework_star.magenta": "Ҡуйы ҡыҙыл",
  "item.minecraft.firework_star.orange": "Хәнәүәт",
  "item.minecraft.firework_star.pink": "Алһыу",
  "item.minecraft.firework_star.purple": "Шәмәхә",
  "item.minecraft.firework_star.red": "Ҡыҙыл",
  "item.minecraft.firework_star.shape": "Билдәһеҙ форма",
  "item.minecraft.firework_star.shape.burst": "Супылдатыу",
  "item.minecraft.firework_star.shape.creeper": "Крипер һымаҡ",
  "item.minecraft.firework_star.shape.large_ball": "Оло йомғаҡ",
  "item.minecraft.firework_star.shape.small_ball": "Кесе шар",
  "item.minecraft.firework_star.shape.star": "Йондоҙ һымаҡ",
  "item.minecraft.firework_star.trail": "Эҙ",
  "item.minecraft.firework_star.white": "Аҡ",
  "item.minecraft.firework_star.yellow": "Һары",
  "item.minecraft.fishing_rod": "Ҡармаҡ",
  "item.minecraft.flint": "Саҡматаш",
  "item.minecraft.flint_and_steel": "Саҡма",
  "item.minecraft.flow_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.flow_armor_trim_smithing_template.new": "«Ағым» биҙәге",
  "item.minecraft.flow_banner_pattern": "Байраҡ биҙәге",
  "item.minecraft.flow_banner_pattern.desc": "Ағым",
  "item.minecraft.flow_banner_pattern.new": "«Ағым» байраҡ биҙәге",
  "item.minecraft.flow_pottery_sherd": "«Ағым» сүлмәк ярсығы",
  "item.minecraft.flower_banner_pattern": "Байраҡ биҙәге",
  "item.minecraft.flower_banner_pattern.desc": "Сәскә",
  "item.minecraft.flower_banner_pattern.new": "«Сәскә» байраҡ биҙәге",
  "item.minecraft.flower_pot": "Сәскә сүлмәге",
  "item.minecraft.fox_spawn_egg": "Төлкө саҡырыу йомортҡаһы",
  "item.minecraft.friend_pottery_shard": "«Дуҫ» сүлмәк ярсығы",
  "item.minecraft.friend_pottery_sherd": "«Дуҫ» сүлмәк ярсығы",
  "item.minecraft.frog_spawn_egg": "Телмәрйен саҡырыу йомортҡаһы",
  "item.minecraft.furnace_minecart": "Вагонетка мейес менән",
  "item.minecraft.ghast_spawn_egg": "Гаст саҡырыу йомортҡаһы",
  "item.minecraft.ghast_tear": "Гаст йәше",
  "item.minecraft.glass_bottle": "Кесе шешә",
  "item.minecraft.glistering_melon_slice": "Ялтырап торған ҡарбуз телеме",
  "item.minecraft.globe_banner_pattern": "Байраҡ биҙәге",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "«Глобус» байраҡ биҙәге",
  "item.minecraft.glow_berries": "Яҡты емештәр",
  "item.minecraft.glow_ink_sac": "Яҡты ҡара тоғо",
  "item.minecraft.glow_item_frame": "Яҡты ҡыҫан",
  "item.minecraft.glow_squid_spawn_egg": "Яҡты һигеҙаяҡ саҡырыу йомортҡаһы",
  "item.minecraft.glowstone_dust": "Яҡтыташ туҙаны",
  "item.minecraft.goat_horn": "Кәзә мөгөҙө",
  "item.minecraft.goat_spawn_egg": "Кәзә саҡырыу йомортҡаһы",
  "item.minecraft.gold_ingot": "Алтын ҡойолма",
  "item.minecraft.gold_nugget": "Алтын киҫәге",
  "item.minecraft.golden_apple": "Алтын алма",
  "item.minecraft.golden_axe": "Алтын балта",
  "item.minecraft.golden_boots": "Алтын итек",
  "item.minecraft.golden_carrot": "Алтын кишер",
  "item.minecraft.golden_chestplate": "Алтын күкрәксә",
  "item.minecraft.golden_helmet": "Алтын торҡа",
  "item.minecraft.golden_hoe": "Алтын кетмән",
  "item.minecraft.golden_horse_armor": "Алтын ат жәбәһе",
  "item.minecraft.golden_leggings": "Алтын салбар",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Алтын кәйлә",
  "item.minecraft.golden_shovel": "Алтын көрәк",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Алтын ҡылыс",
  "item.minecraft.gray_bundle": "Һоро тоҡ",
  "item.minecraft.gray_dye": "Һоро буяу",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Йәшел тоҡ",
  "item.minecraft.green_dye": "Йәшел буяу",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Һаҡлаусы саҡырыу йомортҡаһы",
  "item.minecraft.gunpowder": "Дары",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Өйөрмә",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Бәхетле гаст саҡырыу йомортҡаһы",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Диңгеҙ йөрәге",
  "item.minecraft.heart_pottery_shard": "«Йөрәк» сүлмәк ярсығы",
  "item.minecraft.heart_pottery_sherd": "«Йөрәк» сүлмәк ярсығы",
  "item.minecraft.heartbreak_pottery_shard": "«Яраланған йөрәк» сүлмәк ярсығы",
  "item.minecraft.heartbreak_pottery_sherd": "«Яраланған йөрәк» сүлмәк ярсығы",
  "item.minecraft.hoglin_spawn_egg": "Һоглин саҡырыу йомортҡаһы",
  "item.minecraft.honey_bottle": "Бал шешәһе",
  "item.minecraft.honeycomb": "Ҡорт кәрәҙҙәре",
  "item.minecraft.hopper_minecart": "Вагонетка буранка менән",
  "item.minecraft.horse_spawn_egg": "Ат саҡырыу йомортҡаһы",
  "item.minecraft.host_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "«Олоу» сүлмәк ярсығы",
  "item.minecraft.howl_pottery_sherd": "«Олоу» сүлмәк ярсығы",
  "item.minecraft.husk_spawn_egg": "Үлек саҡырыу йомортҡаһы",
  "item.minecraft.ink_sac": "Ҡара тоғо",
  "item.minecraft.iron_axe": "Тимер балта",
  "item.minecraft.iron_boots": "Тимер итек",
  "item.minecraft.iron_chestplate": "Тимер күкрәксә",
  "item.minecraft.iron_golem_spawn_egg": "Тимер голем саҡырыу йомортҡаһы",
  "item.minecraft.iron_helmet": "Тимер торҡа",
  "item.minecraft.iron_hoe": "Тимер кетмән",
  "item.minecraft.iron_horse_armor": "Тимер ат жәбәһе",
  "item.minecraft.iron_ingot": "Тимер ҡойолма",
  "item.minecraft.iron_leggings": "Тимер салбар",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Тимерҙең киҫәге",
  "item.minecraft.iron_pickaxe": "Тимер кәйлә",
  "item.minecraft.iron_shovel": "Тимер көрәк",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Тимер ҡылыс",
  "item.minecraft.item_frame": "Ҡыҫан",
  "item.minecraft.jungle_boat": "Тропик ағас кәмәһе",
  "item.minecraft.jungle_chest_boat": "Һандыҡлы тропик ағас кәмәһе",
  "item.minecraft.knowledge_book": "Белем китабы",
  "item.minecraft.lapis_lazuli": "Лазурит",
  "item.minecraft.lava_bucket": "Лава силәге",
  "item.minecraft.lead": "Бау",
  "item.minecraft.leather": "Тире",
  "item.minecraft.leather_boots": "Күн итек",
  "item.minecraft.leather_chestplate": "Күн бәрте",
  "item.minecraft.leather_helmet": "Күн торҡа",
  "item.minecraft.leather_horse_armor": "Ат күн ҡалҡаны",
  "item.minecraft.leather_leggings": "Күн салбар",
  "item.minecraft.light_blue_bundle": "Зәңгәр тоҡ",
  "item.minecraft.light_blue_dye": "Зәңгәр буяу",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Аҡһыл һоро тоҡ",
  "item.minecraft.light_gray_dye": "Аҡһыл һоро буяу",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Йәшкелт тоҡ",
  "item.minecraft.lime_dye": "Йәшкелт буяуыс",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Томанлы төнәтмә",
  "item.minecraft.lingering_potion.effect.awkward": "Тоноҡ томанлы төнәтмә",
  "item.minecraft.lingering_potion.effect.empty": "Томанлы булдырмай торған эсемелге",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Томанлы утҡа сыҙамлылыҡ төнәтмә",
  "item.minecraft.lingering_potion.effect.harming": "Томанлы зыян төнәтмәһе",
  "item.minecraft.lingering_potion.effect.healing": "Томанлы шифа төнәтмәһе",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Томанлы күренмәйһеҙлек биреү төнәтмә",
  "item.minecraft.lingering_potion.effect.leaping": "Томанлы һикереү төнәтмәһе",
  "item.minecraft.lingering_potion.effect.levitation": "Томанлы левитация төнәтмәһе",
  "item.minecraft.lingering_potion.effect.luck": "Томанлы уңыш төнәтмәһе",
  "item.minecraft.lingering_potion.effect.mundane": "Ябай томанлы төнәтмә",
  "item.minecraft.lingering_potion.effect.night_vision": "Томанлы төн күреү төнәтмәһе",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Томанлы ағыуланыу төнәтмәһе",
  "item.minecraft.lingering_potion.effect.regeneration": "Томанлы регенерация төнәтмәһе",
  "item.minecraft.lingering_potion.effect.slow_falling": "Томанлы талғын йығылыу төнәтмәһе",
  "item.minecraft.lingering_potion.effect.slowness": "Томанлы аҡрынайыу төнәтмәһе",
  "item.minecraft.lingering_potion.effect.strength": "Томанлы көс төнәтмәһе",
  "item.minecraft.lingering_potion.effect.swiftness": "Томанлы тиҙлек төнәтмә",
  "item.minecraft.lingering_potion.effect.thick": "Ҡуйы томанлы төнәтмә",
  "item.minecraft.lingering_potion.effect.turtle_master": "Томанлы гөбөргәйелдең көс төнәтмәһе",
  "item.minecraft.lingering_potion.effect.water": "Томанлы һыу төнәтмә",
  "item.minecraft.lingering_potion.effect.water_breathing": "Томанлы һыу тын төнәтмәһе",
  "item.minecraft.lingering_potion.effect.weakness": "Томанлы зәғифлек төнәтмәһе",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Лама саҡырыу йомортҡаһы",
  "item.minecraft.lodestone_compass": "Магнитланған компас",
  "item.minecraft.mace": "Суҡмар",
  "item.minecraft.magenta_bundle": "Ҡуйы ҡыҙыл тоҡ",
  "item.minecraft.magenta_dye": "Ҡуйы ҡыҙыл буяу",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Магма ҡуйырығы",
  "item.minecraft.magma_cube_spawn_egg": "Магма кубы саҡырыу йомортҡаһы",
  "item.minecraft.mangrove_boat": "Мангр кәмәһе",
  "item.minecraft.mangrove_chest_boat": "Һандыҡлы мангр ағасынан кәмә",
  "item.minecraft.map": "Буш ерһүрәт",
  "item.minecraft.melon_seeds": "Ҡарбуз орлоҡтары",
  "item.minecraft.melon_slice": "Ҡарбуз телеме",
  "item.minecraft.milk_bucket": "Һөт силәге",
  "item.minecraft.minecart": "Вагонетка",
  "item.minecraft.miner_pottery_shard": "«Шахтасы» сүлмәк ярсығы",
  "item.minecraft.miner_pottery_sherd": "«Шахтасы» сүлмәк ярсығы",
  "item.minecraft.mojang_banner_pattern": "Байраҡ биҙәге",
  "item.minecraft.mojang_banner_pattern.desc": "Бер нәмә",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Мөшрөм саҡырыу йомортҡаһы",
  "item.minecraft.mourner_pottery_shard": "«Ҡайғы» сүлмәк ярсығы",
  "item.minecraft.mourner_pottery_sherd": "«Ҡайғы» сүлмәк ярсығы",
  "item.minecraft.mule_spawn_egg": "Ҡасыр саҡырыу йомортҡаһы",
  "item.minecraft.mushroom_stew": "Быҡтырылған бәшмәк",
  "item.minecraft.music_disc_11": "Пластинка",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Пластинка",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Пластинка",
  "item.minecraft.music_disc_5.desc": "Самуэль Оберг — 5",
  "item.minecraft.music_disc_blocks": "Пластинка",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Пластинка",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Пластинка",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Пластинка",
  "item.minecraft.music_disc_creator.desc": "Лена Рейн — Creator",
  "item.minecraft.music_disc_creator_music_box": "Пластинка",
  "item.minecraft.music_disc_creator_music_box.desc": "Лена Рейн — Creator (музыкаль ҡумта)",
  "item.minecraft.music_disc_far": "Пластинка",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Пластинка",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Пластинка",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Пластинка",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Пластинка",
  "item.minecraft.music_disc_otherside.desc": "Лена Рейн — otherside",
  "item.minecraft.music_disc_pigstep": "Пластинка",
  "item.minecraft.music_disc_pigstep.desc": "Лена Рейн — Pigstep",
  "item.minecraft.music_disc_precipice": "Пластинка",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шероф — Precipice",
  "item.minecraft.music_disc_relic": "Пластинка",
  "item.minecraft.music_disc_relic.desc": "Аарон Шероф — Relic",
  "item.minecraft.music_disc_stal": "Пластинка",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Пластинка",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Пластинка",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Пластинка",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Сей һарыҡ ите",
  "item.minecraft.name_tag": "Ярлыҡ",
  "item.minecraft.nautilus_shell": "Наутилус ҡабырсағы",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Неҙер кирбесе",
  "item.minecraft.nether_star": "Неҙер йондоҙо",
  "item.minecraft.nether_wart": "Неҙер ҡатламы",
  "item.minecraft.netherite_axe": "Неҙерит балтаһы",
  "item.minecraft.netherite_boots": "Неҙерит итеге",
  "item.minecraft.netherite_chestplate": "Неҙеритлы күкрәксә",
  "item.minecraft.netherite_helmet": "Неҙеритлы торҡа",
  "item.minecraft.netherite_hoe": "Неҙерит кетмән",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Неҙерит ҡойолмаһы",
  "item.minecraft.netherite_leggings": "Неҙерит салбары",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Неҙерит кәйләһе",
  "item.minecraft.netherite_scrap": "Неҙерит вайранлығы",
  "item.minecraft.netherite_shovel": "Неҙерит көрәге",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Неҙерит ҡылысы",
  "item.minecraft.netherite_upgrade_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Неҙерит яңыртыуы",
  "item.minecraft.oak_boat": "Имән кәмәһе",
  "item.minecraft.oak_chest_boat": "Һандыҡлы имән кәмәһе",
  "item.minecraft.ocelot_spawn_egg": "Оцелот саҡырыу йомортҡаһы",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Хәнәүәт тоҡ",
  "item.minecraft.orange_dye": "Хәнәүәт буяу",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Рәсем",
  "item.minecraft.pale_oak_boat": "Тоноҡ имән кәмә",
  "item.minecraft.pale_oak_chest_boat": "Һандыҡлы тоноҡ имән кәмә",
  "item.minecraft.panda_spawn_egg": "Панда саҡырыу йомортҡаһы",
  "item.minecraft.paper": "Ҡағыҙ",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Тутыйғош саҡырыу йомортҡаһы",
  "item.minecraft.phantom_membrane": "Өрәк мембранаһы",
  "item.minecraft.phantom_spawn_egg": "Өйрәк саҡырыу йомортҡаһы",
  "item.minecraft.pig_spawn_egg": "Сусҡа саҡырыу йомортҡаһы",
  "item.minecraft.piglin_banner_pattern": "Байраҡ биҙәге",
  "item.minecraft.piglin_banner_pattern.desc": "Томшоҡ",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Тупаҫ пиглин саҡырыу йомортҡаһы",
  "item.minecraft.piglin_spawn_egg": "Пиглин саҡырыу йомортҡаһы",
  "item.minecraft.pillager_spawn_egg": "Юлбаҫар саҡырыу йомортҡаһы",
  "item.minecraft.pink_bundle": "Алһыу тоҡ",
  "item.minecraft.pink_dye": "Алһыу буяу",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Ҡомғансы",
  "item.minecraft.pitcher_pod": "Ҡомғансы ҡуҙағы",
  "item.minecraft.plenty_pottery_shard": "«Муллыҡ» сүлмәк ярсығы",
  "item.minecraft.plenty_pottery_sherd": "«Муллыҡ» сүлмәк ярсығы",
  "item.minecraft.poisonous_potato": "Ағыулы бәрәңге",
  "item.minecraft.polar_bear_spawn_egg": "Аҡ айыу саҡырыу йомортҡаһы",
  "item.minecraft.popped_chorus_fruit": "Ҡурылған хорус емеше",
  "item.minecraft.porkchop": "Сей сусҡа ите",
  "item.minecraft.potato": "Бәрәңге",
  "item.minecraft.potion": "Төнәтмә",
  "item.minecraft.potion.effect.awkward": "Тоноҡ төнәтмә",
  "item.minecraft.potion.effect.empty": "Булдырмай торған төнәтмә",
  "item.minecraft.potion.effect.fire_resistance": "Утҡа сыҙамлы төнәтмә",
  "item.minecraft.potion.effect.harming": "Зыян төнәтмәһе",
  "item.minecraft.potion.effect.healing": "Шифалы төнәтмә",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Күренмәҫлек төнәтмәһе",
  "item.minecraft.potion.effect.leaping": "Һикертеү төнәтмәһе",
  "item.minecraft.potion.effect.levitation": "Левитация төнәтмәһе",
  "item.minecraft.potion.effect.luck": "Уңыш төнәтмәһе",
  "item.minecraft.potion.effect.mundane": "Ябай төнәтмә",
  "item.minecraft.potion.effect.night_vision": "Төн күреү төнәтмәһе",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Ағыуланыу төнәтмәһе",
  "item.minecraft.potion.effect.regeneration": "Регенерация төнәтмәһе",
  "item.minecraft.potion.effect.slow_falling": "Талғын йығылыу төнәтмәһе",
  "item.minecraft.potion.effect.slowness": "Аҡрынайыу төнәтмәһе",
  "item.minecraft.potion.effect.strength": "Көс төнәтмәһе",
  "item.minecraft.potion.effect.swiftness": "Тиҙлек төнәтмәһе",
  "item.minecraft.potion.effect.thick": "Ҡуйы төнәтмә",
  "item.minecraft.potion.effect.turtle_master": "Гөбөргәйелдең көс төнәтмәһе",
  "item.minecraft.potion.effect.water": "Кесе шешә һыу менән",
  "item.minecraft.potion.effect.water_breathing": "Һыуҙың тын төнәтмәһе",
  "item.minecraft.potion.effect.weakness": "Зәғифлек төнәтмәһе",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "«Уҡсы» сүлмәк ярсығы",
  "item.minecraft.pottery_shard_arms_up": "«Ҡулдарҙы өҫкә» сүлмәк ярсығы",
  "item.minecraft.pottery_shard_prize": "«Бүләк» сүлмәк ярсығы",
  "item.minecraft.pottery_shard_skull": "«Баш һөйәге» сүлмәк ярсығы",
  "item.minecraft.powder_snow_bucket": "Көпшәк ҡар силәге",
  "item.minecraft.prismarine_crystals": "Призмарин кристалы",
  "item.minecraft.prismarine_shard": "Призмарин ярсығы",
  "item.minecraft.prize_pottery_shard": "«Бүләк» сүлмәк ярсығы",
  "item.minecraft.prize_pottery_sherd": "«Бүләк» сүлмәк ярсығы",
  "item.minecraft.pufferfish": "Энәбалыҡ",
  "item.minecraft.pufferfish_bucket": "Силәктәге энәбалыҡ",
  "item.minecraft.pufferfish_spawn_egg": "Энәбалыҡ саҡырыу йомортҡаһы",
  "item.minecraft.pumpkin_pie": "Ҡабаҡ бәлеше",
  "item.minecraft.pumpkin_seeds": "Ҡабаҡ орлоҡтары",
  "item.minecraft.purple_bundle": "Шәмәхә тоҡ",
  "item.minecraft.purple_dye": "Шәмәхә буяу",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Неҙер-кварц",
  "item.minecraft.rabbit": "Сей ҡуян ите",
  "item.minecraft.rabbit_foot": "Ҡуян тәпәйе",
  "item.minecraft.rabbit_hide": "Ҡуян тире",
  "item.minecraft.rabbit_spawn_egg": "Ҡуян саҡырыу йомортҡаһы",
  "item.minecraft.rabbit_stew": "Быҡтырылған ҡуян",
  "item.minecraft.raiser_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "«Йыйыусы» биҙәге",
  "item.minecraft.ravager_spawn_egg": "Бөлдөрөүсе саҡырыу йомортҡаһы",
  "item.minecraft.raw_copper": "Эшкәртелмәгән баҡыр",
  "item.minecraft.raw_gold": "Эшкәртелмәгән алтын",
  "item.minecraft.raw_iron": "Эшкәртелмәгән тимер",
  "item.minecraft.recovery_compass": "Ҡайтарыу компасы",
  "item.minecraft.red_bundle": "Ҡыҙыл тоҡ",
  "item.minecraft.red_dye": "Ҡыҙыл буяу",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Редстоун",
  "item.minecraft.resin_brick": "Ыҫмала кирбесе",
  "item.minecraft.resin_clump": "Ыҫмала ҡуйырығы",
  "item.minecraft.rib_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Серек ит",
  "item.minecraft.saddle": "Эйәр",
  "item.minecraft.salmon": "Бешмәгән һөмбаш",
  "item.minecraft.salmon_bucket": "Силәктәге һөмбаш",
  "item.minecraft.salmon_spawn_egg": "Һөмбаш саҡырыу йомортҡаһы",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Ҡалҡанса",
  "item.minecraft.sentry_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "«Ҡарауылсы» биҙәге",
  "item.minecraft.shaper_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "«Рәссам» биҙәге",
  "item.minecraft.sheaf_pottery_shard": "«Көлтә» сүлмәк ярсығы",
  "item.minecraft.sheaf_pottery_sherd": "«Көлтә» сүлмәк ярсығы",
  "item.minecraft.shears": "Ҡайсы",
  "item.minecraft.sheep_spawn_egg": "Һарыҡ саҡырыу йомортҡаһы",
  "item.minecraft.shelter_pottery_shard": "«Ышыҡ ер» сүлмәк ярсығы",
  "item.minecraft.shelter_pottery_sherd": "«Һыйыныу урыны» сүлмәк ярсығы",
  "item.minecraft.shield": "Ҡалҡан",
  "item.minecraft.shield.black": "Ҡара ҡалҡан",
  "item.minecraft.shield.blue": "Күк ҡалҡан",
  "item.minecraft.shield.brown": "Көрән ҡалҡан",
  "item.minecraft.shield.cyan": "Фирүзә ҡалҡан",
  "item.minecraft.shield.gray": "Һоро ҡалҡан",
  "item.minecraft.shield.green": "Йәшел ҡалҡан",
  "item.minecraft.shield.light_blue": "Зәңгәр ҡалҡан",
  "item.minecraft.shield.light_gray": "Аҡһыл һоро ҡалҡан",
  "item.minecraft.shield.lime": "Йәшкелт ҡалҡан",
  "item.minecraft.shield.magenta": "Ҡуйы ҡыҙыл ҡалҡан",
  "item.minecraft.shield.orange": "Хәнәүәт ҡалҡан",
  "item.minecraft.shield.pink": "Алһыу ҡалҡан",
  "item.minecraft.shield.purple": "Шәмәхә ҡалҡан",
  "item.minecraft.shield.red": "Ҡыҙыл ҡалҡан",
  "item.minecraft.shield.white": "Аҡ ҡалҡан",
  "item.minecraft.shield.yellow": "Һары ҡалҡан",
  "item.minecraft.shulker_shell": "Шалкер ҡабығы",
  "item.minecraft.shulker_spawn_egg": "Шалкер саҡырыу йомортҡаһы",
  "item.minecraft.sign": "Билдә",
  "item.minecraft.silence_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.silence_armor_trim_smithing_template.new": "«Һиллек» биҙәге",
  "item.minecraft.silverfish_spawn_egg": "Ҡуңыҙҡорт саҡырыу йомортҡаһы",
  "item.minecraft.skeleton_horse_spawn_egg": "Һөлдә ат саҡырыу йомортҡаһы",
  "item.minecraft.skeleton_spawn_egg": "Һөлдә саҡырыу йомортҡаһы",
  "item.minecraft.skull_banner_pattern": "Байраҡ биҙәге",
  "item.minecraft.skull_banner_pattern.desc": "Баш һөйәге",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "«Баш һөйәге» сүлмәк ярсығы",
  "item.minecraft.skull_pottery_sherd": "«Баш һөйәге» сүлмәк ярсығы",
  "item.minecraft.slime_ball": "Лайлас ҡуйырығы",
  "item.minecraft.slime_spawn_egg": "Лайлас саҡырыу йомортҡаһы",
  "item.minecraft.smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.smithing_template.applies_to": "Ҡулланыш таба:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Ҡойолма йәки кристалл ҡуйығыҙ",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Жәбә",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Жәбә өлөшөн бында ҡуйығыҙ",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ҡойолмалар һәм кристалдар",
  "item.minecraft.smithing_template.ingredients": "Матдәләр:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Неҙерит ҡойолмаһын ҡуйығыҙ",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Алмас ҡорал-ҡорамалы",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Алмас жәбәһен, һуғыш йәки эш ҡоралын өҫтәгеҙ",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Неҙерит ҡойолмаһы",
  "item.minecraft.smithing_template.upgrade": "Яңыртыу: ",
  "item.minecraft.sniffer_spawn_egg": "Еҫкәүсе саҡырыу йомортҡаһы",
  "item.minecraft.snort_pottery_shard": "«Бышҡырыу» сүлмәк ярсығы",
  "item.minecraft.snort_pottery_sherd": "«Бышҡырыу» сүлмәк ярсығы",
  "item.minecraft.snout_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Ҡар бабай саҡырыу йомортҡаһы",
  "item.minecraft.snowball": "Ҡар киҫәге",
  "item.minecraft.spectral_arrow": "Спектраль уғы",
  "item.minecraft.spider_eye": "Үрмәксенең күҙе",
  "item.minecraft.spider_spawn_egg": "Үрмәксе саҡырыу йомортҡаһы",
  "item.minecraft.spire_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Шартлаулы төнәтмә",
  "item.minecraft.splash_potion.effect.awkward": "Шарлай торған тоноҡ төнәтмә",
  "item.minecraft.splash_potion.effect.empty": "Шарлай торған булдырмаған төнәтмә",
  "item.minecraft.splash_potion.effect.fire_resistance": "Шарлай торған утҡа сыҙамлылыҡ төнәтмәһе",
  "item.minecraft.splash_potion.effect.harming": "Шартлай торған зыян төнәтмәһе",
  "item.minecraft.splash_potion.effect.healing": "Шартлай торған шифа төнәтмәһе",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Шарлай торған күренмәйһеҙлек төнәтмәһе",
  "item.minecraft.splash_potion.effect.leaping": "Шарлай торған һикереү төнәтмәһе",
  "item.minecraft.splash_potion.effect.levitation": "Шарлай торған левитация төнәтмәһе",
  "item.minecraft.splash_potion.effect.luck": "Шарлай торған уңыш төнәтмәһе",
  "item.minecraft.splash_potion.effect.mundane": "Шарлай торған ябай төнәтмә",
  "item.minecraft.splash_potion.effect.night_vision": "Шарлай торған төн күреү төнәтмәһе",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Шарлай торған ағыуланыу төнәтмәһе",
  "item.minecraft.splash_potion.effect.regeneration": "Шарлай торған регенерация төнәтмәһе",
  "item.minecraft.splash_potion.effect.slow_falling": "Шарлай торған талғын йығылыу төнәтмәһе",
  "item.minecraft.splash_potion.effect.slowness": "Шарлай торған аҡрынайыу төнәтмәһе",
  "item.minecraft.splash_potion.effect.strength": "Шарлай торған көс төнәтмәһе",
  "item.minecraft.splash_potion.effect.swiftness": "Шарлай торған тиҙлек төнәтмәһе",
  "item.minecraft.splash_potion.effect.thick": "Шарлай торған ҡуйы төнәтмә",
  "item.minecraft.splash_potion.effect.turtle_master": "Шартлай торған гөбөргәйелдең көс төнәтмәһе",
  "item.minecraft.splash_potion.effect.water": "Шарлай торған һыу төнәтмәһе",
  "item.minecraft.splash_potion.effect.water_breathing": "Шартлаулы һыу тын төнәтмәһе",
  "item.minecraft.splash_potion.effect.weakness": "Шарлай торған зәғифлек төнәтмәһе",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Шыршы кәмәһе",
  "item.minecraft.spruce_chest_boat": "Һандыҡлы шыршы кәмәһе",
  "item.minecraft.spyglass": "Күҙәтеү торбаһы",
  "item.minecraft.squid_spawn_egg": "Һигеҙаяҡ саҡырыу йомортҡаһы",
  "item.minecraft.stick": "Таяҡ",
  "item.minecraft.stone_axe": "Таш балта",
  "item.minecraft.stone_hoe": "Таш кетмән",
  "item.minecraft.stone_pickaxe": "Таш кәйлә",
  "item.minecraft.stone_shovel": "Таш көрәк",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Таш ҡылыс",
  "item.minecraft.stray_spawn_egg": "Сырғыя саҡырыу йомортҡаһы",
  "item.minecraft.strider_spawn_egg": "Бойоҡсо саҡырыу йомортҡаһы",
  "item.minecraft.string": "Еп",
  "item.minecraft.sugar": "Ҡәнд",
  "item.minecraft.suspicious_stew": "Серле рагу",
  "item.minecraft.sweet_berries": "Татлы емештәр",
  "item.minecraft.tadpole_bucket": "Сүмесбаш менән силәк",
  "item.minecraft.tadpole_spawn_egg": "Сүмесбаш саҡырыу йомортҡаһы",
  "item.minecraft.tide_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.tide_armor_trim_smithing_template.new": "«Тулҡын» биҙәге",
  "item.minecraft.tipped_arrow": "Эшкәртелгән уғы",
  "item.minecraft.tipped_arrow.effect.awkward": "Эшкәртелгән уҡ",
  "item.minecraft.tipped_arrow.effect.empty": "Булдырмай торған төнәтмә менән эшкәртергән уғы",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Утҡа сыҙамлы уғы",
  "item.minecraft.tipped_arrow.effect.harming": "Зыян уғы",
  "item.minecraft.tipped_arrow.effect.healing": "Шифалы уғы",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Күренмәҫлек уғы",
  "item.minecraft.tipped_arrow.effect.leaping": "Һикертеү уғы",
  "item.minecraft.tipped_arrow.effect.levitation": "Левитация уғы",
  "item.minecraft.tipped_arrow.effect.luck": "Уңыш уғы",
  "item.minecraft.tipped_arrow.effect.mundane": "Эшкәртелгән уҡ",
  "item.minecraft.tipped_arrow.effect.night_vision": "Төн күреү уғы",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Ағыуланыу уғы",
  "item.minecraft.tipped_arrow.effect.regeneration": "Регенерациялау уғы",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Талғын йығылыу уғы",
  "item.minecraft.tipped_arrow.effect.slowness": "Аҡрынайыу уғы",
  "item.minecraft.tipped_arrow.effect.strength": "Көс уғы",
  "item.minecraft.tipped_arrow.effect.swiftness": "Тиҙлек уғы",
  "item.minecraft.tipped_arrow.effect.thick": "Эшкәртелгән уҡ",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Гөбөргәйелдең көс уғы",
  "item.minecraft.tipped_arrow.effect.water": "Шартлай торған уҡ",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Һыу тын уғы",
  "item.minecraft.tipped_arrow.effect.weakness": "Зәғифлек уғы",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Динамитлы вагонетка",
  "item.minecraft.torchflower_seeds": "Сыраҡгөл орлоҡтары",
  "item.minecraft.totem_of_undying": "Үлемһеҙлек тотемы",
  "item.minecraft.trader_llama_spawn_egg": "Һатыусының ламаһы саҡырыу йомортҡаһы",
  "item.minecraft.trial_key": "Һынау асҡысы",
  "item.minecraft.trident": "Өс теш",
  "item.minecraft.tropical_fish": "Тропик балығы",
  "item.minecraft.tropical_fish_bucket": "Силәктәге тропик балығы",
  "item.minecraft.tropical_fish_spawn_egg": "Тропик балыҡ саҡырыу йомортҡаһы",
  "item.minecraft.turtle_helmet": "Гөбөргәйелдең ҡабығы",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Гөбөргәйел саҡырыу йоморотҡаһы",
  "item.minecraft.vex_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Ҡоротҡос саҡырыу йомортҡаһы",
  "item.minecraft.villager_spawn_egg": "Тороусы саҡырыу йомортҡаһы",
  "item.minecraft.vindicator_spawn_egg": "Көрәшсе саҡырыу йомортҡаһы",
  "item.minecraft.wandering_trader_spawn_egg": "Гиҙеүсе сәүдәгәр саҡырыу йомортҡаһы",
  "item.minecraft.ward_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Рәҡип саҡырыу йомортҡаһы",
  "item.minecraft.warped_fungus_on_a_stick": "Боҙолған бәшмәк менән ҡармаҡ",
  "item.minecraft.water_bucket": "Һыу силәге",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Бойҙай",
  "item.minecraft.wheat_seeds": "Бойҙай орлоҡтары",
  "item.minecraft.white_bundle": "Аҡ тоҡ",
  "item.minecraft.white_dye": "Аҡ буяу",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Тимерсе ҡалыбы",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Ел ҡоролмаһы",
  "item.minecraft.witch_spawn_egg": "Мауыҙ саҡырыу йомортҡаһы",
  "item.minecraft.wither_skeleton_spawn_egg": "Виҙер-һөлдә саҡырыу йомортҡаһы",
  "item.minecraft.wither_spawn_egg": "Виҙер саҡырыу йомортҡаһы",
  "item.minecraft.wolf_armor": "Бүре жәбәһе",
  "item.minecraft.wolf_spawn_egg": "Бүре саҡырыу йомортҡаһы",
  "item.minecraft.wooden_axe": "Ағас балта",
  "item.minecraft.wooden_hoe": "Ағас кетмән",
  "item.minecraft.wooden_pickaxe": "Ағас кәйлә",
  "item.minecraft.wooden_shovel": "Ағас көрәк",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Ағас ҡылыс",
  "item.minecraft.writable_book": "Китап һәм ҡәләм",
  "item.minecraft.written_book": "Яҙылған китап",
  "item.minecraft.yellow_bundle": "Һары тоҡ",
  "item.minecraft.yellow_dye": "Һары буяу",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Зоглин саҡырыу йомортҡаһы",
  "item.minecraft.zombie_horse_spawn_egg": "Зомби ат саҡырыу йомортҡаһы",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Зомби саҡырыу йомортҡаһы",
  "item.minecraft.zombie_villager_spawn_egg": "Зомби-тороусы саҡырыу йомортҡаһы",
  "item.minecraft.zombified_piglin_spawn_egg": "Зомбиланған пиглин саҡырыу йомортҡаһы"
}
export const ba_ru = items; 
